export default `/* Host Variables */
:host {
  --grid-auto-row-height: 0;
  --grid-fill-color: var(--ids-layout-grid-color-background);
  --grid-text-color: var(--ids-layout-grid-color-text);
  --min-col-width: 0;
  --max-col-width: 1fr;
  --min-row-height: 0;
  --max-row-height: 1fr;
  --min-row-width: 1fr;
  --sticky-position: 0;
}

/* Grid Variables */
/* Host and ids-layout-grid Base */
:host,
.ids-layout-grid {
  display: grid;
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
  justify-content: start;
  box-sizing: border-box;
}

:host([hidden]) {
  display: none;
}

/* Grid Columms - Base */
:host([cols="1"]),
.ids-layout-grid-cols-1 {
  width: 100%;
  grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="1"]),
.ids-layout-grid > .ids-layout-grid-col-span-1 {
  grid-column: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([col-start="1"]),
.ids-layout-grid > .ids-layout-grid-col-start-1 {
  grid-column-start: 1;
}

:host(.ids-layout-grid) > ::slotted([col-end="1"]),
.ids-layout-grid > .ids-layout-grid-col-end-1 {
  grid-column-end: 1;
}

:host([cols="2"]),
.ids-layout-grid-cols-2 {
  width: 100%;
  grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="2"]),
.ids-layout-grid > .ids-layout-grid-col-span-2 {
  grid-column: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([col-start="2"]),
.ids-layout-grid > .ids-layout-grid-col-start-2 {
  grid-column-start: 2;
}

:host(.ids-layout-grid) > ::slotted([col-end="2"]),
.ids-layout-grid > .ids-layout-grid-col-end-2 {
  grid-column-end: 2;
}

:host([cols="3"]),
.ids-layout-grid-cols-3 {
  width: 100%;
  grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="3"]),
.ids-layout-grid > .ids-layout-grid-col-span-3 {
  grid-column: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([col-start="3"]),
.ids-layout-grid > .ids-layout-grid-col-start-3 {
  grid-column-start: 3;
}

:host(.ids-layout-grid) > ::slotted([col-end="3"]),
.ids-layout-grid > .ids-layout-grid-col-end-3 {
  grid-column-end: 3;
}

:host([cols="4"]),
.ids-layout-grid-cols-4 {
  width: 100%;
  grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="4"]),
.ids-layout-grid > .ids-layout-grid-col-span-4 {
  grid-column: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([col-start="4"]),
.ids-layout-grid > .ids-layout-grid-col-start-4 {
  grid-column-start: 4;
}

:host(.ids-layout-grid) > ::slotted([col-end="4"]),
.ids-layout-grid > .ids-layout-grid-col-end-4 {
  grid-column-end: 4;
}

:host([cols="5"]),
.ids-layout-grid-cols-5 {
  width: 100%;
  grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="5"]),
.ids-layout-grid > .ids-layout-grid-col-span-5 {
  grid-column: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([col-start="5"]),
.ids-layout-grid > .ids-layout-grid-col-start-5 {
  grid-column-start: 5;
}

:host(.ids-layout-grid) > ::slotted([col-end="5"]),
.ids-layout-grid > .ids-layout-grid-col-end-5 {
  grid-column-end: 5;
}

:host([cols="6"]),
.ids-layout-grid-cols-6 {
  width: 100%;
  grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="6"]),
.ids-layout-grid > .ids-layout-grid-col-span-6 {
  grid-column: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([col-start="6"]),
.ids-layout-grid > .ids-layout-grid-col-start-6 {
  grid-column-start: 6;
}

:host(.ids-layout-grid) > ::slotted([col-end="6"]),
.ids-layout-grid > .ids-layout-grid-col-end-6 {
  grid-column-end: 6;
}

:host([cols="7"]),
.ids-layout-grid-cols-7 {
  width: 100%;
  grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="7"]),
.ids-layout-grid > .ids-layout-grid-col-span-7 {
  grid-column: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([col-start="7"]),
.ids-layout-grid > .ids-layout-grid-col-start-7 {
  grid-column-start: 7;
}

:host(.ids-layout-grid) > ::slotted([col-end="7"]),
.ids-layout-grid > .ids-layout-grid-col-end-7 {
  grid-column-end: 7;
}

:host([cols="8"]),
.ids-layout-grid-cols-8 {
  width: 100%;
  grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="8"]),
.ids-layout-grid > .ids-layout-grid-col-span-8 {
  grid-column: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([col-start="8"]),
.ids-layout-grid > .ids-layout-grid-col-start-8 {
  grid-column-start: 8;
}

:host(.ids-layout-grid) > ::slotted([col-end="8"]),
.ids-layout-grid > .ids-layout-grid-col-end-8 {
  grid-column-end: 8;
}

:host([cols="9"]),
.ids-layout-grid-cols-9 {
  width: 100%;
  grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="9"]),
.ids-layout-grid > .ids-layout-grid-col-span-9 {
  grid-column: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([col-start="9"]),
.ids-layout-grid > .ids-layout-grid-col-start-9 {
  grid-column-start: 9;
}

:host(.ids-layout-grid) > ::slotted([col-end="9"]),
.ids-layout-grid > .ids-layout-grid-col-end-9 {
  grid-column-end: 9;
}

:host([cols="10"]),
.ids-layout-grid-cols-10 {
  width: 100%;
  grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="10"]),
.ids-layout-grid > .ids-layout-grid-col-span-10 {
  grid-column: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([col-start="10"]),
.ids-layout-grid > .ids-layout-grid-col-start-10 {
  grid-column-start: 10;
}

:host(.ids-layout-grid) > ::slotted([col-end="10"]),
.ids-layout-grid > .ids-layout-grid-col-end-10 {
  grid-column-end: 10;
}

:host([cols="11"]),
.ids-layout-grid-cols-11 {
  width: 100%;
  grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="11"]),
.ids-layout-grid > .ids-layout-grid-col-span-11 {
  grid-column: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([col-start="11"]),
.ids-layout-grid > .ids-layout-grid-col-start-11 {
  grid-column-start: 11;
}

:host(.ids-layout-grid) > ::slotted([col-end="11"]),
.ids-layout-grid > .ids-layout-grid-col-end-11 {
  grid-column-end: 11;
}

:host([cols="12"]),
.ids-layout-grid-cols-12 {
  width: 100%;
  grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="12"]),
.ids-layout-grid > .ids-layout-grid-col-span-12 {
  grid-column: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([col-start="12"]),
.ids-layout-grid > .ids-layout-grid-col-start-12 {
  grid-column-start: 12;
}

:host(.ids-layout-grid) > ::slotted([col-end="12"]),
.ids-layout-grid > .ids-layout-grid-col-end-12 {
  grid-column-end: 12;
}

:host([cols="13"]),
.ids-layout-grid-cols-13 {
  width: 100%;
  grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="13"]),
.ids-layout-grid > .ids-layout-grid-col-span-13 {
  grid-column: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([col-start="13"]),
.ids-layout-grid > .ids-layout-grid-col-start-13 {
  grid-column-start: 13;
}

:host(.ids-layout-grid) > ::slotted([col-end="13"]),
.ids-layout-grid > .ids-layout-grid-col-end-13 {
  grid-column-end: 13;
}

:host([cols="14"]),
.ids-layout-grid-cols-14 {
  width: 100%;
  grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="14"]),
.ids-layout-grid > .ids-layout-grid-col-span-14 {
  grid-column: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([col-start="14"]),
.ids-layout-grid > .ids-layout-grid-col-start-14 {
  grid-column-start: 14;
}

:host(.ids-layout-grid) > ::slotted([col-end="14"]),
.ids-layout-grid > .ids-layout-grid-col-end-14 {
  grid-column-end: 14;
}

:host([cols="15"]),
.ids-layout-grid-cols-15 {
  width: 100%;
  grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="15"]),
.ids-layout-grid > .ids-layout-grid-col-span-15 {
  grid-column: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([col-start="15"]),
.ids-layout-grid > .ids-layout-grid-col-start-15 {
  grid-column-start: 15;
}

:host(.ids-layout-grid) > ::slotted([col-end="15"]),
.ids-layout-grid > .ids-layout-grid-col-end-15 {
  grid-column-end: 15;
}

:host([cols="16"]),
.ids-layout-grid-cols-16 {
  width: 100%;
  grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="16"]),
.ids-layout-grid > .ids-layout-grid-col-span-16 {
  grid-column: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([col-start="16"]),
.ids-layout-grid > .ids-layout-grid-col-start-16 {
  grid-column-start: 16;
}

:host(.ids-layout-grid) > ::slotted([col-end="16"]),
.ids-layout-grid > .ids-layout-grid-col-end-16 {
  grid-column-end: 16;
}

:host([cols="17"]),
.ids-layout-grid-cols-17 {
  width: 100%;
  grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="17"]),
.ids-layout-grid > .ids-layout-grid-col-span-17 {
  grid-column: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([col-start="17"]),
.ids-layout-grid > .ids-layout-grid-col-start-17 {
  grid-column-start: 17;
}

:host(.ids-layout-grid) > ::slotted([col-end="17"]),
.ids-layout-grid > .ids-layout-grid-col-end-17 {
  grid-column-end: 17;
}

:host([cols="18"]),
.ids-layout-grid-cols-18 {
  width: 100%;
  grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="18"]),
.ids-layout-grid > .ids-layout-grid-col-span-18 {
  grid-column: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([col-start="18"]),
.ids-layout-grid > .ids-layout-grid-col-start-18 {
  grid-column-start: 18;
}

:host(.ids-layout-grid) > ::slotted([col-end="18"]),
.ids-layout-grid > .ids-layout-grid-col-end-18 {
  grid-column-end: 18;
}

:host([cols="19"]),
.ids-layout-grid-cols-19 {
  width: 100%;
  grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="19"]),
.ids-layout-grid > .ids-layout-grid-col-span-19 {
  grid-column: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([col-start="19"]),
.ids-layout-grid > .ids-layout-grid-col-start-19 {
  grid-column-start: 19;
}

:host(.ids-layout-grid) > ::slotted([col-end="19"]),
.ids-layout-grid > .ids-layout-grid-col-end-19 {
  grid-column-end: 19;
}

:host([cols="20"]),
.ids-layout-grid-cols-20 {
  width: 100%;
  grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="20"]),
.ids-layout-grid > .ids-layout-grid-col-span-20 {
  grid-column: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([col-start="20"]),
.ids-layout-grid > .ids-layout-grid-col-start-20 {
  grid-column-start: 20;
}

:host(.ids-layout-grid) > ::slotted([col-end="20"]),
.ids-layout-grid > .ids-layout-grid-col-end-20 {
  grid-column-end: 20;
}

:host([cols="21"]),
.ids-layout-grid-cols-21 {
  width: 100%;
  grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="21"]),
.ids-layout-grid > .ids-layout-grid-col-span-21 {
  grid-column: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([col-start="21"]),
.ids-layout-grid > .ids-layout-grid-col-start-21 {
  grid-column-start: 21;
}

:host(.ids-layout-grid) > ::slotted([col-end="21"]),
.ids-layout-grid > .ids-layout-grid-col-end-21 {
  grid-column-end: 21;
}

:host([cols="22"]),
.ids-layout-grid-cols-22 {
  width: 100%;
  grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="22"]),
.ids-layout-grid > .ids-layout-grid-col-span-22 {
  grid-column: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([col-start="22"]),
.ids-layout-grid > .ids-layout-grid-col-start-22 {
  grid-column-start: 22;
}

:host(.ids-layout-grid) > ::slotted([col-end="22"]),
.ids-layout-grid > .ids-layout-grid-col-end-22 {
  grid-column-end: 22;
}

:host([cols="23"]),
.ids-layout-grid-cols-23 {
  width: 100%;
  grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="23"]),
.ids-layout-grid > .ids-layout-grid-col-span-23 {
  grid-column: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([col-start="23"]),
.ids-layout-grid > .ids-layout-grid-col-start-23 {
  grid-column-start: 23;
}

:host(.ids-layout-grid) > ::slotted([col-end="23"]),
.ids-layout-grid > .ids-layout-grid-col-end-23 {
  grid-column-end: 23;
}

:host([cols="24"]),
.ids-layout-grid-cols-24 {
  width: 100%;
  grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="24"]),
.ids-layout-grid > .ids-layout-grid-col-span-24 {
  grid-column: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([col-start="24"]),
.ids-layout-grid > .ids-layout-grid-col-start-24 {
  grid-column-start: 24;
}

:host(.ids-layout-grid) > ::slotted([col-end="24"]),
.ids-layout-grid > .ids-layout-grid-col-end-24 {
  grid-column-end: 24;
}

/* Grid Rows - Base */
:host([rows="1"]),
.ids-layout-grid-rows-1 {
  grid-template-rows: repeat(1, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="1"]),
.ids-layout-grid > .ids-layout-grid-row-span-1 {
  grid-row: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([order="1"]),
.ids-layout-grid > .ids-layout-grid-order-1 {
  order: 1;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="2"]),
.ids-layout-grid-rows-2 {
  grid-template-rows: repeat(2, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="2"]),
.ids-layout-grid > .ids-layout-grid-row-span-2 {
  grid-row: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([order="2"]),
.ids-layout-grid > .ids-layout-grid-order-2 {
  order: 2;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="3"]),
.ids-layout-grid-rows-3 {
  grid-template-rows: repeat(3, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="3"]),
.ids-layout-grid > .ids-layout-grid-row-span-3 {
  grid-row: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([order="3"]),
.ids-layout-grid > .ids-layout-grid-order-3 {
  order: 3;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="4"]),
.ids-layout-grid-rows-4 {
  grid-template-rows: repeat(4, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="4"]),
.ids-layout-grid > .ids-layout-grid-row-span-4 {
  grid-row: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([order="4"]),
.ids-layout-grid > .ids-layout-grid-order-4 {
  order: 4;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="5"]),
.ids-layout-grid-rows-5 {
  grid-template-rows: repeat(5, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="5"]),
.ids-layout-grid > .ids-layout-grid-row-span-5 {
  grid-row: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([order="5"]),
.ids-layout-grid > .ids-layout-grid-order-5 {
  order: 5;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="6"]),
.ids-layout-grid-rows-6 {
  grid-template-rows: repeat(6, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="6"]),
.ids-layout-grid > .ids-layout-grid-row-span-6 {
  grid-row: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([order="6"]),
.ids-layout-grid > .ids-layout-grid-order-6 {
  order: 6;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="7"]),
.ids-layout-grid-rows-7 {
  grid-template-rows: repeat(7, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="7"]),
.ids-layout-grid > .ids-layout-grid-row-span-7 {
  grid-row: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([order="7"]),
.ids-layout-grid > .ids-layout-grid-order-7 {
  order: 7;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="8"]),
.ids-layout-grid-rows-8 {
  grid-template-rows: repeat(8, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="8"]),
.ids-layout-grid > .ids-layout-grid-row-span-8 {
  grid-row: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([order="8"]),
.ids-layout-grid > .ids-layout-grid-order-8 {
  order: 8;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="9"]),
.ids-layout-grid-rows-9 {
  grid-template-rows: repeat(9, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="9"]),
.ids-layout-grid > .ids-layout-grid-row-span-9 {
  grid-row: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([order="9"]),
.ids-layout-grid > .ids-layout-grid-order-9 {
  order: 9;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="10"]),
.ids-layout-grid-rows-10 {
  grid-template-rows: repeat(10, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="10"]),
.ids-layout-grid > .ids-layout-grid-row-span-10 {
  grid-row: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([order="10"]),
.ids-layout-grid > .ids-layout-grid-order-10 {
  order: 10;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="11"]),
.ids-layout-grid-rows-11 {
  grid-template-rows: repeat(11, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="11"]),
.ids-layout-grid > .ids-layout-grid-row-span-11 {
  grid-row: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([order="11"]),
.ids-layout-grid > .ids-layout-grid-order-11 {
  order: 11;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="12"]),
.ids-layout-grid-rows-12 {
  grid-template-rows: repeat(12, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="12"]),
.ids-layout-grid > .ids-layout-grid-row-span-12 {
  grid-row: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([order="12"]),
.ids-layout-grid > .ids-layout-grid-order-12 {
  order: 12;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="13"]),
.ids-layout-grid-rows-13 {
  grid-template-rows: repeat(13, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="13"]),
.ids-layout-grid > .ids-layout-grid-row-span-13 {
  grid-row: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([order="13"]),
.ids-layout-grid > .ids-layout-grid-order-13 {
  order: 13;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="14"]),
.ids-layout-grid-rows-14 {
  grid-template-rows: repeat(14, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="14"]),
.ids-layout-grid > .ids-layout-grid-row-span-14 {
  grid-row: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([order="14"]),
.ids-layout-grid > .ids-layout-grid-order-14 {
  order: 14;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="15"]),
.ids-layout-grid-rows-15 {
  grid-template-rows: repeat(15, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="15"]),
.ids-layout-grid > .ids-layout-grid-row-span-15 {
  grid-row: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([order="15"]),
.ids-layout-grid > .ids-layout-grid-order-15 {
  order: 15;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="16"]),
.ids-layout-grid-rows-16 {
  grid-template-rows: repeat(16, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="16"]),
.ids-layout-grid > .ids-layout-grid-row-span-16 {
  grid-row: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([order="16"]),
.ids-layout-grid > .ids-layout-grid-order-16 {
  order: 16;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="17"]),
.ids-layout-grid-rows-17 {
  grid-template-rows: repeat(17, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="17"]),
.ids-layout-grid > .ids-layout-grid-row-span-17 {
  grid-row: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([order="17"]),
.ids-layout-grid > .ids-layout-grid-order-17 {
  order: 17;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="18"]),
.ids-layout-grid-rows-18 {
  grid-template-rows: repeat(18, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="18"]),
.ids-layout-grid > .ids-layout-grid-row-span-18 {
  grid-row: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([order="18"]),
.ids-layout-grid > .ids-layout-grid-order-18 {
  order: 18;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="19"]),
.ids-layout-grid-rows-19 {
  grid-template-rows: repeat(19, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="19"]),
.ids-layout-grid > .ids-layout-grid-row-span-19 {
  grid-row: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([order="19"]),
.ids-layout-grid > .ids-layout-grid-order-19 {
  order: 19;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="20"]),
.ids-layout-grid-rows-20 {
  grid-template-rows: repeat(20, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="20"]),
.ids-layout-grid > .ids-layout-grid-row-span-20 {
  grid-row: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([order="20"]),
.ids-layout-grid > .ids-layout-grid-order-20 {
  order: 20;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="21"]),
.ids-layout-grid-rows-21 {
  grid-template-rows: repeat(21, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="21"]),
.ids-layout-grid > .ids-layout-grid-row-span-21 {
  grid-row: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([order="21"]),
.ids-layout-grid > .ids-layout-grid-order-21 {
  order: 21;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="22"]),
.ids-layout-grid-rows-22 {
  grid-template-rows: repeat(22, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="22"]),
.ids-layout-grid > .ids-layout-grid-row-span-22 {
  grid-row: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([order="22"]),
.ids-layout-grid > .ids-layout-grid-order-22 {
  order: 22;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="23"]),
.ids-layout-grid-rows-23 {
  grid-template-rows: repeat(23, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="23"]),
.ids-layout-grid > .ids-layout-grid-row-span-23 {
  grid-row: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([order="23"]),
.ids-layout-grid > .ids-layout-grid-order-23 {
  order: 23;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="24"]),
.ids-layout-grid-rows-24 {
  grid-template-rows: repeat(24, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="24"]),
.ids-layout-grid > .ids-layout-grid-row-span-24 {
  grid-row: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([order="24"]),
.ids-layout-grid > .ids-layout-grid-order-24 {
  order: 24;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="25"]),
.ids-layout-grid-rows-25 {
  grid-template-rows: repeat(25, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="25"]),
.ids-layout-grid > .ids-layout-grid-row-span-25 {
  grid-row: span 25/span 25;
}

:host(.ids-layout-grid) > ::slotted([order="25"]),
.ids-layout-grid > .ids-layout-grid-order-25 {
  order: 25;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="26"]),
.ids-layout-grid-rows-26 {
  grid-template-rows: repeat(26, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="26"]),
.ids-layout-grid > .ids-layout-grid-row-span-26 {
  grid-row: span 26/span 26;
}

:host(.ids-layout-grid) > ::slotted([order="26"]),
.ids-layout-grid > .ids-layout-grid-order-26 {
  order: 26;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="27"]),
.ids-layout-grid-rows-27 {
  grid-template-rows: repeat(27, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="27"]),
.ids-layout-grid > .ids-layout-grid-row-span-27 {
  grid-row: span 27/span 27;
}

:host(.ids-layout-grid) > ::slotted([order="27"]),
.ids-layout-grid > .ids-layout-grid-order-27 {
  order: 27;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="28"]),
.ids-layout-grid-rows-28 {
  grid-template-rows: repeat(28, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="28"]),
.ids-layout-grid > .ids-layout-grid-row-span-28 {
  grid-row: span 28/span 28;
}

:host(.ids-layout-grid) > ::slotted([order="28"]),
.ids-layout-grid > .ids-layout-grid-order-28 {
  order: 28;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="29"]),
.ids-layout-grid-rows-29 {
  grid-template-rows: repeat(29, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="29"]),
.ids-layout-grid > .ids-layout-grid-row-span-29 {
  grid-row: span 29/span 29;
}

:host(.ids-layout-grid) > ::slotted([order="29"]),
.ids-layout-grid > .ids-layout-grid-order-29 {
  order: 29;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="30"]),
.ids-layout-grid-rows-30 {
  grid-template-rows: repeat(30, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="30"]),
.ids-layout-grid > .ids-layout-grid-row-span-30 {
  grid-row: span 30/span 30;
}

:host(.ids-layout-grid) > ::slotted([order="30"]),
.ids-layout-grid > .ids-layout-grid-order-30 {
  order: 30;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="31"]),
.ids-layout-grid-rows-31 {
  grid-template-rows: repeat(31, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="31"]),
.ids-layout-grid > .ids-layout-grid-row-span-31 {
  grid-row: span 31/span 31;
}

:host(.ids-layout-grid) > ::slotted([order="31"]),
.ids-layout-grid > .ids-layout-grid-order-31 {
  order: 31;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="32"]),
.ids-layout-grid-rows-32 {
  grid-template-rows: repeat(32, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="32"]),
.ids-layout-grid > .ids-layout-grid-row-span-32 {
  grid-row: span 32/span 32;
}

:host(.ids-layout-grid) > ::slotted([order="32"]),
.ids-layout-grid > .ids-layout-grid-order-32 {
  order: 32;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="33"]),
.ids-layout-grid-rows-33 {
  grid-template-rows: repeat(33, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="33"]),
.ids-layout-grid > .ids-layout-grid-row-span-33 {
  grid-row: span 33/span 33;
}

:host(.ids-layout-grid) > ::slotted([order="33"]),
.ids-layout-grid > .ids-layout-grid-order-33 {
  order: 33;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="34"]),
.ids-layout-grid-rows-34 {
  grid-template-rows: repeat(34, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="34"]),
.ids-layout-grid > .ids-layout-grid-row-span-34 {
  grid-row: span 34/span 34;
}

:host(.ids-layout-grid) > ::slotted([order="34"]),
.ids-layout-grid > .ids-layout-grid-order-34 {
  order: 34;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="35"]),
.ids-layout-grid-rows-35 {
  grid-template-rows: repeat(35, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="35"]),
.ids-layout-grid > .ids-layout-grid-row-span-35 {
  grid-row: span 35/span 35;
}

:host(.ids-layout-grid) > ::slotted([order="35"]),
.ids-layout-grid > .ids-layout-grid-order-35 {
  order: 35;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="36"]),
.ids-layout-grid-rows-36 {
  grid-template-rows: repeat(36, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="36"]),
.ids-layout-grid > .ids-layout-grid-row-span-36 {
  grid-row: span 36/span 36;
}

:host(.ids-layout-grid) > ::slotted([order="36"]),
.ids-layout-grid > .ids-layout-grid-order-36 {
  order: 36;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="37"]),
.ids-layout-grid-rows-37 {
  grid-template-rows: repeat(37, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="37"]),
.ids-layout-grid > .ids-layout-grid-row-span-37 {
  grid-row: span 37/span 37;
}

:host(.ids-layout-grid) > ::slotted([order="37"]),
.ids-layout-grid > .ids-layout-grid-order-37 {
  order: 37;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="38"]),
.ids-layout-grid-rows-38 {
  grid-template-rows: repeat(38, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="38"]),
.ids-layout-grid > .ids-layout-grid-row-span-38 {
  grid-row: span 38/span 38;
}

:host(.ids-layout-grid) > ::slotted([order="38"]),
.ids-layout-grid > .ids-layout-grid-order-38 {
  order: 38;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="39"]),
.ids-layout-grid-rows-39 {
  grid-template-rows: repeat(39, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="39"]),
.ids-layout-grid > .ids-layout-grid-row-span-39 {
  grid-row: span 39/span 39;
}

:host(.ids-layout-grid) > ::slotted([order="39"]),
.ids-layout-grid > .ids-layout-grid-order-39 {
  order: 39;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="40"]),
.ids-layout-grid-rows-40 {
  grid-template-rows: repeat(40, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="40"]),
.ids-layout-grid > .ids-layout-grid-row-span-40 {
  grid-row: span 40/span 40;
}

:host(.ids-layout-grid) > ::slotted([order="40"]),
.ids-layout-grid > .ids-layout-grid-order-40 {
  order: 40;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="41"]),
.ids-layout-grid-rows-41 {
  grid-template-rows: repeat(41, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="41"]),
.ids-layout-grid > .ids-layout-grid-row-span-41 {
  grid-row: span 41/span 41;
}

:host(.ids-layout-grid) > ::slotted([order="41"]),
.ids-layout-grid > .ids-layout-grid-order-41 {
  order: 41;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="42"]),
.ids-layout-grid-rows-42 {
  grid-template-rows: repeat(42, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="42"]),
.ids-layout-grid > .ids-layout-grid-row-span-42 {
  grid-row: span 42/span 42;
}

:host(.ids-layout-grid) > ::slotted([order="42"]),
.ids-layout-grid > .ids-layout-grid-order-42 {
  order: 42;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="43"]),
.ids-layout-grid-rows-43 {
  grid-template-rows: repeat(43, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="43"]),
.ids-layout-grid > .ids-layout-grid-row-span-43 {
  grid-row: span 43/span 43;
}

:host(.ids-layout-grid) > ::slotted([order="43"]),
.ids-layout-grid > .ids-layout-grid-order-43 {
  order: 43;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="44"]),
.ids-layout-grid-rows-44 {
  grid-template-rows: repeat(44, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="44"]),
.ids-layout-grid > .ids-layout-grid-row-span-44 {
  grid-row: span 44/span 44;
}

:host(.ids-layout-grid) > ::slotted([order="44"]),
.ids-layout-grid > .ids-layout-grid-order-44 {
  order: 44;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="45"]),
.ids-layout-grid-rows-45 {
  grid-template-rows: repeat(45, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="45"]),
.ids-layout-grid > .ids-layout-grid-row-span-45 {
  grid-row: span 45/span 45;
}

:host(.ids-layout-grid) > ::slotted([order="45"]),
.ids-layout-grid > .ids-layout-grid-order-45 {
  order: 45;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="46"]),
.ids-layout-grid-rows-46 {
  grid-template-rows: repeat(46, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="46"]),
.ids-layout-grid > .ids-layout-grid-row-span-46 {
  grid-row: span 46/span 46;
}

:host(.ids-layout-grid) > ::slotted([order="46"]),
.ids-layout-grid > .ids-layout-grid-order-46 {
  order: 46;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="47"]),
.ids-layout-grid-rows-47 {
  grid-template-rows: repeat(47, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="47"]),
.ids-layout-grid > .ids-layout-grid-row-span-47 {
  grid-row: span 47/span 47;
}

:host(.ids-layout-grid) > ::slotted([order="47"]),
.ids-layout-grid > .ids-layout-grid-order-47 {
  order: 47;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="48"]),
.ids-layout-grid-rows-48 {
  grid-template-rows: repeat(48, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="48"]),
.ids-layout-grid > .ids-layout-grid-row-span-48 {
  grid-row: span 48/span 48;
}

:host(.ids-layout-grid) > ::slotted([order="48"]),
.ids-layout-grid > .ids-layout-grid-order-48 {
  order: 48;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="49"]),
.ids-layout-grid-rows-49 {
  grid-template-rows: repeat(49, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="49"]),
.ids-layout-grid > .ids-layout-grid-row-span-49 {
  grid-row: span 49/span 49;
}

:host(.ids-layout-grid) > ::slotted([order="49"]),
.ids-layout-grid > .ids-layout-grid-order-49 {
  order: 49;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="50"]),
.ids-layout-grid-rows-50 {
  grid-template-rows: repeat(50, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="50"]),
.ids-layout-grid > .ids-layout-grid-row-span-50 {
  grid-row: span 50/span 50;
}

:host(.ids-layout-grid) > ::slotted([order="50"]),
.ids-layout-grid > .ids-layout-grid-order-50 {
  order: 50;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

@media (width >= 0) {
  :host(:not([enable-container])[cols-xs="1"]),
  .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="2"]),
  .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="3"]),
  .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="4"]),
  .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="5"]),
  .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="6"]),
  .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="7"]),
  .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="8"]),
  .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="9"]),
  .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="10"]),
  .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="11"]),
  .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="12"]),
  .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="13"]),
  .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="14"]),
  .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="15"]),
  .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="16"]),
  .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="17"]),
  .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="18"]),
  .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="19"]),
  .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="20"]),
  .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="21"]),
  .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="22"]),
  .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="23"]),
  .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="24"]),
  .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-xs="1"]),
  .ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-xs="2"]),
  .ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-xs="3"]),
  .ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-xs="4"]),
  .ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-xs="5"]),
  .ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-xs="6"]),
  .ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-xs="7"]),
  .ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-xs="8"]),
  .ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-xs="9"]),
  .ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-xs="10"]),
  .ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-xs="11"]),
  .ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-xs="12"]),
  .ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-xs="13"]),
  .ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-xs="14"]),
  .ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-xs="15"]),
  .ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-xs="16"]),
  .ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-xs="17"]),
  .ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-xs="18"]),
  .ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-xs="19"]),
  .ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-xs="20"]),
  .ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-xs="21"]),
  .ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-xs="22"]),
  .ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-xs="23"]),
  .ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-xs="24"]),
  .ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-xs="25"]),
  .ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-xs="26"]),
  .ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-xs="27"]),
  .ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-xs="28"]),
  .ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-xs="29"]),
  .ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-xs="30"]),
  .ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-xs="31"]),
  .ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-xs="32"]),
  .ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-xs="33"]),
  .ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-xs="34"]),
  .ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-xs="35"]),
  .ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-xs="36"]),
  .ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-xs="37"]),
  .ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-xs="38"]),
  .ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-xs="39"]),
  .ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-xs="40"]),
  .ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-xs="41"]),
  .ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-xs="42"]),
  .ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-xs="43"]),
  .ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-xs="44"]),
  .ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-xs="45"]),
  .ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-xs="46"]),
  .ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-xs="47"]),
  .ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-xs="48"]),
  .ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-xs="49"]),
  .ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-xs="50"]),
  .ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-xs=row]), .ids-layout-grid-flow-xs-row {
    grid-auto-flow: row;
  }
  :host([flow-xs=column]), .ids-layout-grid-flow-xs-col {
    grid-auto-flow: column;
  }
  :host([flow-xs=dense]), .ids-layout-grid-flow-xs-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xs=row-dense]), .ids-layout-grid-flow-xs-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xs=column-dense]), .ids-layout-grid-flow-xs-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 767px) {
  :host(:not([enable-container])[cols-sm="1"]),
  .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="2"]),
  .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="3"]),
  .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="4"]),
  .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="5"]),
  .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="6"]),
  .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="7"]),
  .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="8"]),
  .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="9"]),
  .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="10"]),
  .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="11"]),
  .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="12"]),
  .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="13"]),
  .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="14"]),
  .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="15"]),
  .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="16"]),
  .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="17"]),
  .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="18"]),
  .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="19"]),
  .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="20"]),
  .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="21"]),
  .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="22"]),
  .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="23"]),
  .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="24"]),
  .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-sm="1"]),
  .ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-sm="2"]),
  .ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-sm="3"]),
  .ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-sm="4"]),
  .ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-sm="5"]),
  .ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-sm="6"]),
  .ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-sm="7"]),
  .ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-sm="8"]),
  .ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-sm="9"]),
  .ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-sm="10"]),
  .ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-sm="11"]),
  .ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-sm="12"]),
  .ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-sm="13"]),
  .ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-sm="14"]),
  .ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-sm="15"]),
  .ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-sm="16"]),
  .ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-sm="17"]),
  .ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-sm="18"]),
  .ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-sm="19"]),
  .ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-sm="20"]),
  .ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-sm="21"]),
  .ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-sm="22"]),
  .ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-sm="23"]),
  .ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-sm="24"]),
  .ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-sm="25"]),
  .ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-sm="26"]),
  .ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-sm="27"]),
  .ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-sm="28"]),
  .ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-sm="29"]),
  .ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-sm="30"]),
  .ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-sm="31"]),
  .ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-sm="32"]),
  .ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-sm="33"]),
  .ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-sm="34"]),
  .ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-sm="35"]),
  .ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-sm="36"]),
  .ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-sm="37"]),
  .ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-sm="38"]),
  .ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-sm="39"]),
  .ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-sm="40"]),
  .ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-sm="41"]),
  .ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-sm="42"]),
  .ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-sm="43"]),
  .ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-sm="44"]),
  .ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-sm="45"]),
  .ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-sm="46"]),
  .ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-sm="47"]),
  .ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-sm="48"]),
  .ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-sm="49"]),
  .ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-sm="50"]),
  .ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-sm=row]), .ids-layout-grid-flow-sm-row {
    grid-auto-flow: row;
  }
  :host([flow-sm=column]), .ids-layout-grid-flow-sm-col {
    grid-auto-flow: column;
  }
  :host([flow-sm=dense]), .ids-layout-grid-flow-sm-dense {
    grid-auto-flow: dense;
  }
  :host([flow-sm=row-dense]), .ids-layout-grid-flow-sm-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-sm=column-dense]), .ids-layout-grid-flow-sm-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 927px) {
  :host(:not([enable-container])[cols-md="1"]),
  .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="2"]),
  .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="3"]),
  .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="4"]),
  .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="5"]),
  .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="6"]),
  .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="7"]),
  .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="8"]),
  .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="9"]),
  .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="10"]),
  .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="11"]),
  .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="12"]),
  .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="13"]),
  .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="14"]),
  .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="15"]),
  .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="16"]),
  .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="17"]),
  .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="18"]),
  .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="19"]),
  .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="20"]),
  .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="21"]),
  .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="22"]),
  .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="23"]),
  .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="24"]),
  .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-md="1"]),
  .ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-md="2"]),
  .ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-md="3"]),
  .ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-md="4"]),
  .ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-md="5"]),
  .ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-md="6"]),
  .ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-md="7"]),
  .ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-md="8"]),
  .ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-md="9"]),
  .ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-md="10"]),
  .ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-md="11"]),
  .ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-md="12"]),
  .ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-md="13"]),
  .ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-md="14"]),
  .ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-md="15"]),
  .ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-md="16"]),
  .ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-md="17"]),
  .ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-md="18"]),
  .ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-md="19"]),
  .ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-md="20"]),
  .ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-md="21"]),
  .ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-md="22"]),
  .ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-md="23"]),
  .ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-md="24"]),
  .ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-md="25"]),
  .ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-md="26"]),
  .ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-md="27"]),
  .ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-md="28"]),
  .ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-md="29"]),
  .ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-md="30"]),
  .ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-md="31"]),
  .ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-md="32"]),
  .ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-md="33"]),
  .ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-md="34"]),
  .ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-md="35"]),
  .ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-md="36"]),
  .ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-md="37"]),
  .ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-md="38"]),
  .ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-md="39"]),
  .ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-md="40"]),
  .ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-md="41"]),
  .ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-md="42"]),
  .ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-md="43"]),
  .ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-md="44"]),
  .ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-md="45"]),
  .ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-md="46"]),
  .ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-md="47"]),
  .ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-md="48"]),
  .ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-md="49"]),
  .ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-md="50"]),
  .ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-md=row]), .ids-layout-grid-flow-md-row {
    grid-auto-flow: row;
  }
  :host([flow-md=column]), .ids-layout-grid-flow-md-col {
    grid-auto-flow: column;
  }
  :host([flow-md=dense]), .ids-layout-grid-flow-md-dense {
    grid-auto-flow: dense;
  }
  :host([flow-md=row-dense]), .ids-layout-grid-flow-md-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-md=column-dense]), .ids-layout-grid-flow-md-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 928px) {
  :host(:not([enable-container])[cols-lg="1"]),
  .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="2"]),
  .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="3"]),
  .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="4"]),
  .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="5"]),
  .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="6"]),
  .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="7"]),
  .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="8"]),
  .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="9"]),
  .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="10"]),
  .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="11"]),
  .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="12"]),
  .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="13"]),
  .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="14"]),
  .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="15"]),
  .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="16"]),
  .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="17"]),
  .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="18"]),
  .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="19"]),
  .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="20"]),
  .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="21"]),
  .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="22"]),
  .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="23"]),
  .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="24"]),
  .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-lg="1"]),
  .ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-lg="2"]),
  .ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-lg="3"]),
  .ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-lg="4"]),
  .ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-lg="5"]),
  .ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-lg="6"]),
  .ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-lg="7"]),
  .ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-lg="8"]),
  .ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-lg="9"]),
  .ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-lg="10"]),
  .ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-lg="11"]),
  .ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-lg="12"]),
  .ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-lg="13"]),
  .ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-lg="14"]),
  .ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-lg="15"]),
  .ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-lg="16"]),
  .ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-lg="17"]),
  .ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-lg="18"]),
  .ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-lg="19"]),
  .ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-lg="20"]),
  .ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-lg="21"]),
  .ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-lg="22"]),
  .ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-lg="23"]),
  .ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-lg="24"]),
  .ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-lg="25"]),
  .ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-lg="26"]),
  .ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-lg="27"]),
  .ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-lg="28"]),
  .ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-lg="29"]),
  .ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-lg="30"]),
  .ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-lg="31"]),
  .ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-lg="32"]),
  .ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-lg="33"]),
  .ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-lg="34"]),
  .ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-lg="35"]),
  .ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-lg="36"]),
  .ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-lg="37"]),
  .ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-lg="38"]),
  .ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-lg="39"]),
  .ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-lg="40"]),
  .ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-lg="41"]),
  .ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-lg="42"]),
  .ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-lg="43"]),
  .ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-lg="44"]),
  .ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-lg="45"]),
  .ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-lg="46"]),
  .ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-lg="47"]),
  .ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-lg="48"]),
  .ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-lg="49"]),
  .ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-lg="50"]),
  .ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-lg=row]), .ids-layout-grid-flow-lg-row {
    grid-auto-flow: row;
  }
  :host([flow-lg=column]), .ids-layout-grid-flow-lg-col {
    grid-auto-flow: column;
  }
  :host([flow-lg=dense]), .ids-layout-grid-flow-lg-dense {
    grid-auto-flow: dense;
  }
  :host([flow-lg=row-dense]), .ids-layout-grid-flow-lg-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-lg=column-dense]), .ids-layout-grid-flow-lg-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 1183px) {
  :host(:not([enable-container])[cols-xl="1"]),
  .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="2"]),
  .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="3"]),
  .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="4"]),
  .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="5"]),
  .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="6"]),
  .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="7"]),
  .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="8"]),
  .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="9"]),
  .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="10"]),
  .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="11"]),
  .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="12"]),
  .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="13"]),
  .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="14"]),
  .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="15"]),
  .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="16"]),
  .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="17"]),
  .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="18"]),
  .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="19"]),
  .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="20"]),
  .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="21"]),
  .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="22"]),
  .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="23"]),
  .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="24"]),
  .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-xl="1"]),
  .ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-xl="2"]),
  .ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-xl="3"]),
  .ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-xl="4"]),
  .ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-xl="5"]),
  .ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-xl="6"]),
  .ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-xl="7"]),
  .ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-xl="8"]),
  .ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-xl="9"]),
  .ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-xl="10"]),
  .ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-xl="11"]),
  .ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-xl="12"]),
  .ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-xl="13"]),
  .ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-xl="14"]),
  .ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-xl="15"]),
  .ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-xl="16"]),
  .ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-xl="17"]),
  .ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-xl="18"]),
  .ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-xl="19"]),
  .ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-xl="20"]),
  .ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-xl="21"]),
  .ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-xl="22"]),
  .ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-xl="23"]),
  .ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-xl="24"]),
  .ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-xl="25"]),
  .ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-xl="26"]),
  .ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-xl="27"]),
  .ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-xl="28"]),
  .ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-xl="29"]),
  .ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-xl="30"]),
  .ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-xl="31"]),
  .ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-xl="32"]),
  .ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-xl="33"]),
  .ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-xl="34"]),
  .ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-xl="35"]),
  .ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-xl="36"]),
  .ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-xl="37"]),
  .ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-xl="38"]),
  .ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-xl="39"]),
  .ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-xl="40"]),
  .ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-xl="41"]),
  .ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-xl="42"]),
  .ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-xl="43"]),
  .ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-xl="44"]),
  .ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-xl="45"]),
  .ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-xl="46"]),
  .ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-xl="47"]),
  .ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-xl="48"]),
  .ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-xl="49"]),
  .ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-xl="50"]),
  .ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-xl=row]), .ids-layout-grid-flow-xl-row {
    grid-auto-flow: row;
  }
  :host([flow-xl=column]), .ids-layout-grid-flow-xl-col {
    grid-auto-flow: column;
  }
  :host([flow-xl=dense]), .ids-layout-grid-flow-xl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xl=row-dense]), .ids-layout-grid-flow-xl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xl=column-dense]), .ids-layout-grid-flow-xl-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 2463px) {
  :host(:not([enable-container])[cols-xxl="1"]),
  .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="2"]),
  .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="3"]),
  .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="4"]),
  .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="5"]),
  .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="6"]),
  .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="7"]),
  .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="8"]),
  .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="9"]),
  .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="10"]),
  .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="11"]),
  .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="12"]),
  .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="13"]),
  .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="14"]),
  .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="15"]),
  .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="16"]),
  .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="17"]),
  .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="18"]),
  .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="19"]),
  .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="20"]),
  .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="21"]),
  .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="22"]),
  .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="23"]),
  .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="24"]),
  .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-xxl="1"]),
  .ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-xxl="2"]),
  .ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-xxl="3"]),
  .ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-xxl="4"]),
  .ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-xxl="5"]),
  .ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-xxl="6"]),
  .ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-xxl="7"]),
  .ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-xxl="8"]),
  .ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-xxl="9"]),
  .ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-xxl="10"]),
  .ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-xxl="11"]),
  .ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-xxl="12"]),
  .ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-xxl="13"]),
  .ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-xxl="14"]),
  .ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-xxl="15"]),
  .ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-xxl="16"]),
  .ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-xxl="17"]),
  .ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-xxl="18"]),
  .ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-xxl="19"]),
  .ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-xxl="20"]),
  .ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-xxl="21"]),
  .ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-xxl="22"]),
  .ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-xxl="23"]),
  .ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-xxl="24"]),
  .ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-xxl="25"]),
  .ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-xxl="26"]),
  .ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-xxl="27"]),
  .ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-xxl="28"]),
  .ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-xxl="29"]),
  .ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-xxl="30"]),
  .ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-xxl="31"]),
  .ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-xxl="32"]),
  .ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-xxl="33"]),
  .ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-xxl="34"]),
  .ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-xxl="35"]),
  .ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-xxl="36"]),
  .ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-xxl="37"]),
  .ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-xxl="38"]),
  .ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-xxl="39"]),
  .ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-xxl="40"]),
  .ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-xxl="41"]),
  .ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-xxl="42"]),
  .ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-xxl="43"]),
  .ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-xxl="44"]),
  .ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-xxl="45"]),
  .ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-xxl="46"]),
  .ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-xxl="47"]),
  .ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-xxl="48"]),
  .ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-xxl="49"]),
  .ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-xxl="50"]),
  .ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-xxl=row]), .ids-layout-grid-flow-xxl-row {
    grid-auto-flow: row;
  }
  :host([flow-xxl=column]), .ids-layout-grid-flow-xxl-col {
    grid-auto-flow: column;
  }
  :host([flow-xxl=dense]), .ids-layout-grid-flow-xxl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xxl=row-dense]), .ids-layout-grid-flow-xxl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xxl=column-dense]), .ids-layout-grid-flow-xxl-col-dense {
    grid-auto-flow: column dense;
  }
}
@container (width >= 0) {
  :host([cols-xs="1"]), .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="2"]), .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="3"]), .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="4"]), .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="5"]), .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="6"]), .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="7"]), .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="8"]), .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="9"]), .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="10"]), .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="11"]), .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="12"]), .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="13"]), .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="14"]), .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="15"]), .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="16"]), .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="17"]), .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="18"]), .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="19"]), .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="20"]), .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="21"]), .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="22"]), .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="23"]), .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="24"]), .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 767px) {
  :host([cols-sm="1"]), .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="2"]), .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="3"]), .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="4"]), .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="5"]), .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="6"]), .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="7"]), .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="8"]), .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="9"]), .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="10"]), .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="11"]), .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="12"]), .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="13"]), .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="14"]), .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="15"]), .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="16"]), .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="17"]), .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="18"]), .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="19"]), .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="20"]), .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="21"]), .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="22"]), .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="23"]), .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="24"]), .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 927px) {
  :host([cols-md="1"]), .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="2"]), .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="3"]), .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="4"]), .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="5"]), .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="6"]), .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="7"]), .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="8"]), .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="9"]), .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="10"]), .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="11"]), .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="12"]), .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="13"]), .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="14"]), .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="15"]), .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="16"]), .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="17"]), .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="18"]), .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="19"]), .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="20"]), .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="21"]), .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="22"]), .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="23"]), .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="24"]), .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 928px) {
  :host([cols-lg="1"]), .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="2"]), .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="3"]), .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="4"]), .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="5"]), .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="6"]), .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="7"]), .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="8"]), .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="9"]), .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="10"]), .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="11"]), .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="12"]), .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="13"]), .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="14"]), .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="15"]), .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="16"]), .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="17"]), .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="18"]), .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="19"]), .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="20"]), .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="21"]), .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="22"]), .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="23"]), .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="24"]), .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 1183px) {
  :host([cols-xl="1"]), .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="2"]), .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="3"]), .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="4"]), .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="5"]), .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="6"]), .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="7"]), .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="8"]), .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="9"]), .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="10"]), .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="11"]), .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="12"]), .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="13"]), .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="14"]), .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="15"]), .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="16"]), .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="17"]), .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="18"]), .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="19"]), .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="20"]), .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="21"]), .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="22"]), .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="23"]), .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="24"]), .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 2463px) {
  :host([cols-xxl="1"]), .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="2"]), .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="3"]), .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="4"]), .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="5"]), .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="6"]), .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="7"]), .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="8"]), .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="9"]), .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="10"]), .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="11"]), .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="12"]), .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="13"]), .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="14"]), .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="15"]), .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="16"]), .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="17"]), .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="18"]), .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="19"]), .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="20"]), .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="21"]), .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="22"]), .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="23"]), .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="24"]), .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
/* Use media queries by default */
@media (width >= 320px) {
  :host(:not([enable-container])) > ::slotted([col-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xs="1"], :host(:not([enable-container])).ids-layout-grid-rows-xs-1,
  .ids-layout-grid:not([enable-container])[rows-xs="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="2"], :host(:not([enable-container])).ids-layout-grid-rows-xs-2,
  .ids-layout-grid:not([enable-container])[rows-xs="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="3"], :host(:not([enable-container])).ids-layout-grid-rows-xs-3,
  .ids-layout-grid:not([enable-container])[rows-xs="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="4"], :host(:not([enable-container])).ids-layout-grid-rows-xs-4,
  .ids-layout-grid:not([enable-container])[rows-xs="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="5"], :host(:not([enable-container])).ids-layout-grid-rows-xs-5,
  .ids-layout-grid:not([enable-container])[rows-xs="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="6"], :host(:not([enable-container])).ids-layout-grid-rows-xs-6,
  .ids-layout-grid:not([enable-container])[rows-xs="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="7"], :host(:not([enable-container])).ids-layout-grid-rows-xs-7,
  .ids-layout-grid:not([enable-container])[rows-xs="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="8"], :host(:not([enable-container])).ids-layout-grid-rows-xs-8,
  .ids-layout-grid:not([enable-container])[rows-xs="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="9"], :host(:not([enable-container])).ids-layout-grid-rows-xs-9,
  .ids-layout-grid:not([enable-container])[rows-xs="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="10"], :host(:not([enable-container])).ids-layout-grid-rows-xs-10,
  .ids-layout-grid:not([enable-container])[rows-xs="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="11"], :host(:not([enable-container])).ids-layout-grid-rows-xs-11,
  .ids-layout-grid:not([enable-container])[rows-xs="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="12"], :host(:not([enable-container])).ids-layout-grid-rows-xs-12,
  .ids-layout-grid:not([enable-container])[rows-xs="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="13"], :host(:not([enable-container])).ids-layout-grid-rows-xs-13,
  .ids-layout-grid:not([enable-container])[rows-xs="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="14"], :host(:not([enable-container])).ids-layout-grid-rows-xs-14,
  .ids-layout-grid:not([enable-container])[rows-xs="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="15"], :host(:not([enable-container])).ids-layout-grid-rows-xs-15,
  .ids-layout-grid:not([enable-container])[rows-xs="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="16"], :host(:not([enable-container])).ids-layout-grid-rows-xs-16,
  .ids-layout-grid:not([enable-container])[rows-xs="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="17"], :host(:not([enable-container])).ids-layout-grid-rows-xs-17,
  .ids-layout-grid:not([enable-container])[rows-xs="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="18"], :host(:not([enable-container])).ids-layout-grid-rows-xs-18,
  .ids-layout-grid:not([enable-container])[rows-xs="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="19"], :host(:not([enable-container])).ids-layout-grid-rows-xs-19,
  .ids-layout-grid:not([enable-container])[rows-xs="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="20"], :host(:not([enable-container])).ids-layout-grid-rows-xs-20,
  .ids-layout-grid:not([enable-container])[rows-xs="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="21"], :host(:not([enable-container])).ids-layout-grid-rows-xs-21,
  .ids-layout-grid:not([enable-container])[rows-xs="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="22"], :host(:not([enable-container])).ids-layout-grid-rows-xs-22,
  .ids-layout-grid:not([enable-container])[rows-xs="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="23"], :host(:not([enable-container])).ids-layout-grid-rows-xs-23,
  .ids-layout-grid:not([enable-container])[rows-xs="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="24"], :host(:not([enable-container])).ids-layout-grid-rows-xs-24,
  .ids-layout-grid:not([enable-container])[rows-xs="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="25"], :host(:not([enable-container])).ids-layout-grid-rows-xs-25,
  .ids-layout-grid:not([enable-container])[rows-xs="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="26"], :host(:not([enable-container])).ids-layout-grid-rows-xs-26,
  .ids-layout-grid:not([enable-container])[rows-xs="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="27"], :host(:not([enable-container])).ids-layout-grid-rows-xs-27,
  .ids-layout-grid:not([enable-container])[rows-xs="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="28"], :host(:not([enable-container])).ids-layout-grid-rows-xs-28,
  .ids-layout-grid:not([enable-container])[rows-xs="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="29"], :host(:not([enable-container])).ids-layout-grid-rows-xs-29,
  .ids-layout-grid:not([enable-container])[rows-xs="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="30"], :host(:not([enable-container])).ids-layout-grid-rows-xs-30,
  .ids-layout-grid:not([enable-container])[rows-xs="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="31"], :host(:not([enable-container])).ids-layout-grid-rows-xs-31,
  .ids-layout-grid:not([enable-container])[rows-xs="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="32"], :host(:not([enable-container])).ids-layout-grid-rows-xs-32,
  .ids-layout-grid:not([enable-container])[rows-xs="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="33"], :host(:not([enable-container])).ids-layout-grid-rows-xs-33,
  .ids-layout-grid:not([enable-container])[rows-xs="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="34"], :host(:not([enable-container])).ids-layout-grid-rows-xs-34,
  .ids-layout-grid:not([enable-container])[rows-xs="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="35"], :host(:not([enable-container])).ids-layout-grid-rows-xs-35,
  .ids-layout-grid:not([enable-container])[rows-xs="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="36"], :host(:not([enable-container])).ids-layout-grid-rows-xs-36,
  .ids-layout-grid:not([enable-container])[rows-xs="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="37"], :host(:not([enable-container])).ids-layout-grid-rows-xs-37,
  .ids-layout-grid:not([enable-container])[rows-xs="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="38"], :host(:not([enable-container])).ids-layout-grid-rows-xs-38,
  .ids-layout-grid:not([enable-container])[rows-xs="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="39"], :host(:not([enable-container])).ids-layout-grid-rows-xs-39,
  .ids-layout-grid:not([enable-container])[rows-xs="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="40"], :host(:not([enable-container])).ids-layout-grid-rows-xs-40,
  .ids-layout-grid:not([enable-container])[rows-xs="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="41"], :host(:not([enable-container])).ids-layout-grid-rows-xs-41,
  .ids-layout-grid:not([enable-container])[rows-xs="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="42"], :host(:not([enable-container])).ids-layout-grid-rows-xs-42,
  .ids-layout-grid:not([enable-container])[rows-xs="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="43"], :host(:not([enable-container])).ids-layout-grid-rows-xs-43,
  .ids-layout-grid:not([enable-container])[rows-xs="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="44"], :host(:not([enable-container])).ids-layout-grid-rows-xs-44,
  .ids-layout-grid:not([enable-container])[rows-xs="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="45"], :host(:not([enable-container])).ids-layout-grid-rows-xs-45,
  .ids-layout-grid:not([enable-container])[rows-xs="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="46"], :host(:not([enable-container])).ids-layout-grid-rows-xs-46,
  .ids-layout-grid:not([enable-container])[rows-xs="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="47"], :host(:not([enable-container])).ids-layout-grid-rows-xs-47,
  .ids-layout-grid:not([enable-container])[rows-xs="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="48"], :host(:not([enable-container])).ids-layout-grid-rows-xs-48,
  .ids-layout-grid:not([enable-container])[rows-xs="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="49"], :host(:not([enable-container])).ids-layout-grid-rows-xs-49,
  .ids-layout-grid:not([enable-container])[rows-xs="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="50"], :host(:not([enable-container])).ids-layout-grid-rows-xs-50,
  .ids-layout-grid:not([enable-container])[rows-xs="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xs]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xs]) {
    display: block;
  }
}
@media (width >= 767px) {
  :host(:not([enable-container])) > ::slotted([col-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-sm="1"], :host(:not([enable-container])).ids-layout-grid-rows-sm-1,
  .ids-layout-grid:not([enable-container])[rows-sm="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="2"], :host(:not([enable-container])).ids-layout-grid-rows-sm-2,
  .ids-layout-grid:not([enable-container])[rows-sm="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="3"], :host(:not([enable-container])).ids-layout-grid-rows-sm-3,
  .ids-layout-grid:not([enable-container])[rows-sm="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="4"], :host(:not([enable-container])).ids-layout-grid-rows-sm-4,
  .ids-layout-grid:not([enable-container])[rows-sm="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="5"], :host(:not([enable-container])).ids-layout-grid-rows-sm-5,
  .ids-layout-grid:not([enable-container])[rows-sm="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="6"], :host(:not([enable-container])).ids-layout-grid-rows-sm-6,
  .ids-layout-grid:not([enable-container])[rows-sm="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="7"], :host(:not([enable-container])).ids-layout-grid-rows-sm-7,
  .ids-layout-grid:not([enable-container])[rows-sm="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="8"], :host(:not([enable-container])).ids-layout-grid-rows-sm-8,
  .ids-layout-grid:not([enable-container])[rows-sm="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="9"], :host(:not([enable-container])).ids-layout-grid-rows-sm-9,
  .ids-layout-grid:not([enable-container])[rows-sm="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="10"], :host(:not([enable-container])).ids-layout-grid-rows-sm-10,
  .ids-layout-grid:not([enable-container])[rows-sm="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="11"], :host(:not([enable-container])).ids-layout-grid-rows-sm-11,
  .ids-layout-grid:not([enable-container])[rows-sm="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="12"], :host(:not([enable-container])).ids-layout-grid-rows-sm-12,
  .ids-layout-grid:not([enable-container])[rows-sm="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="13"], :host(:not([enable-container])).ids-layout-grid-rows-sm-13,
  .ids-layout-grid:not([enable-container])[rows-sm="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="14"], :host(:not([enable-container])).ids-layout-grid-rows-sm-14,
  .ids-layout-grid:not([enable-container])[rows-sm="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="15"], :host(:not([enable-container])).ids-layout-grid-rows-sm-15,
  .ids-layout-grid:not([enable-container])[rows-sm="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="16"], :host(:not([enable-container])).ids-layout-grid-rows-sm-16,
  .ids-layout-grid:not([enable-container])[rows-sm="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="17"], :host(:not([enable-container])).ids-layout-grid-rows-sm-17,
  .ids-layout-grid:not([enable-container])[rows-sm="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="18"], :host(:not([enable-container])).ids-layout-grid-rows-sm-18,
  .ids-layout-grid:not([enable-container])[rows-sm="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="19"], :host(:not([enable-container])).ids-layout-grid-rows-sm-19,
  .ids-layout-grid:not([enable-container])[rows-sm="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="20"], :host(:not([enable-container])).ids-layout-grid-rows-sm-20,
  .ids-layout-grid:not([enable-container])[rows-sm="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="21"], :host(:not([enable-container])).ids-layout-grid-rows-sm-21,
  .ids-layout-grid:not([enable-container])[rows-sm="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="22"], :host(:not([enable-container])).ids-layout-grid-rows-sm-22,
  .ids-layout-grid:not([enable-container])[rows-sm="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="23"], :host(:not([enable-container])).ids-layout-grid-rows-sm-23,
  .ids-layout-grid:not([enable-container])[rows-sm="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="24"], :host(:not([enable-container])).ids-layout-grid-rows-sm-24,
  .ids-layout-grid:not([enable-container])[rows-sm="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="25"], :host(:not([enable-container])).ids-layout-grid-rows-sm-25,
  .ids-layout-grid:not([enable-container])[rows-sm="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="26"], :host(:not([enable-container])).ids-layout-grid-rows-sm-26,
  .ids-layout-grid:not([enable-container])[rows-sm="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="27"], :host(:not([enable-container])).ids-layout-grid-rows-sm-27,
  .ids-layout-grid:not([enable-container])[rows-sm="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="28"], :host(:not([enable-container])).ids-layout-grid-rows-sm-28,
  .ids-layout-grid:not([enable-container])[rows-sm="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="29"], :host(:not([enable-container])).ids-layout-grid-rows-sm-29,
  .ids-layout-grid:not([enable-container])[rows-sm="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="30"], :host(:not([enable-container])).ids-layout-grid-rows-sm-30,
  .ids-layout-grid:not([enable-container])[rows-sm="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="31"], :host(:not([enable-container])).ids-layout-grid-rows-sm-31,
  .ids-layout-grid:not([enable-container])[rows-sm="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="32"], :host(:not([enable-container])).ids-layout-grid-rows-sm-32,
  .ids-layout-grid:not([enable-container])[rows-sm="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="33"], :host(:not([enable-container])).ids-layout-grid-rows-sm-33,
  .ids-layout-grid:not([enable-container])[rows-sm="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="34"], :host(:not([enable-container])).ids-layout-grid-rows-sm-34,
  .ids-layout-grid:not([enable-container])[rows-sm="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="35"], :host(:not([enable-container])).ids-layout-grid-rows-sm-35,
  .ids-layout-grid:not([enable-container])[rows-sm="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="36"], :host(:not([enable-container])).ids-layout-grid-rows-sm-36,
  .ids-layout-grid:not([enable-container])[rows-sm="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="37"], :host(:not([enable-container])).ids-layout-grid-rows-sm-37,
  .ids-layout-grid:not([enable-container])[rows-sm="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="38"], :host(:not([enable-container])).ids-layout-grid-rows-sm-38,
  .ids-layout-grid:not([enable-container])[rows-sm="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="39"], :host(:not([enable-container])).ids-layout-grid-rows-sm-39,
  .ids-layout-grid:not([enable-container])[rows-sm="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="40"], :host(:not([enable-container])).ids-layout-grid-rows-sm-40,
  .ids-layout-grid:not([enable-container])[rows-sm="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="41"], :host(:not([enable-container])).ids-layout-grid-rows-sm-41,
  .ids-layout-grid:not([enable-container])[rows-sm="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="42"], :host(:not([enable-container])).ids-layout-grid-rows-sm-42,
  .ids-layout-grid:not([enable-container])[rows-sm="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="43"], :host(:not([enable-container])).ids-layout-grid-rows-sm-43,
  .ids-layout-grid:not([enable-container])[rows-sm="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="44"], :host(:not([enable-container])).ids-layout-grid-rows-sm-44,
  .ids-layout-grid:not([enable-container])[rows-sm="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="45"], :host(:not([enable-container])).ids-layout-grid-rows-sm-45,
  .ids-layout-grid:not([enable-container])[rows-sm="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="46"], :host(:not([enable-container])).ids-layout-grid-rows-sm-46,
  .ids-layout-grid:not([enable-container])[rows-sm="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="47"], :host(:not([enable-container])).ids-layout-grid-rows-sm-47,
  .ids-layout-grid:not([enable-container])[rows-sm="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="48"], :host(:not([enable-container])).ids-layout-grid-rows-sm-48,
  .ids-layout-grid:not([enable-container])[rows-sm="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="49"], :host(:not([enable-container])).ids-layout-grid-rows-sm-49,
  .ids-layout-grid:not([enable-container])[rows-sm="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="50"], :host(:not([enable-container])).ids-layout-grid-rows-sm-50,
  .ids-layout-grid:not([enable-container])[rows-sm="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=sm]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=sm]) {
    display: block;
  }
}
@media (width >= 927px) {
  :host(:not([enable-container])) > ::slotted([col-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-md="1"], :host(:not([enable-container])).ids-layout-grid-rows-md-1,
  .ids-layout-grid:not([enable-container])[rows-md="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="2"], :host(:not([enable-container])).ids-layout-grid-rows-md-2,
  .ids-layout-grid:not([enable-container])[rows-md="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="3"], :host(:not([enable-container])).ids-layout-grid-rows-md-3,
  .ids-layout-grid:not([enable-container])[rows-md="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="4"], :host(:not([enable-container])).ids-layout-grid-rows-md-4,
  .ids-layout-grid:not([enable-container])[rows-md="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="5"], :host(:not([enable-container])).ids-layout-grid-rows-md-5,
  .ids-layout-grid:not([enable-container])[rows-md="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="6"], :host(:not([enable-container])).ids-layout-grid-rows-md-6,
  .ids-layout-grid:not([enable-container])[rows-md="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="7"], :host(:not([enable-container])).ids-layout-grid-rows-md-7,
  .ids-layout-grid:not([enable-container])[rows-md="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="8"], :host(:not([enable-container])).ids-layout-grid-rows-md-8,
  .ids-layout-grid:not([enable-container])[rows-md="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="9"], :host(:not([enable-container])).ids-layout-grid-rows-md-9,
  .ids-layout-grid:not([enable-container])[rows-md="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="10"], :host(:not([enable-container])).ids-layout-grid-rows-md-10,
  .ids-layout-grid:not([enable-container])[rows-md="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="11"], :host(:not([enable-container])).ids-layout-grid-rows-md-11,
  .ids-layout-grid:not([enable-container])[rows-md="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="12"], :host(:not([enable-container])).ids-layout-grid-rows-md-12,
  .ids-layout-grid:not([enable-container])[rows-md="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="13"], :host(:not([enable-container])).ids-layout-grid-rows-md-13,
  .ids-layout-grid:not([enable-container])[rows-md="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="14"], :host(:not([enable-container])).ids-layout-grid-rows-md-14,
  .ids-layout-grid:not([enable-container])[rows-md="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="15"], :host(:not([enable-container])).ids-layout-grid-rows-md-15,
  .ids-layout-grid:not([enable-container])[rows-md="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="16"], :host(:not([enable-container])).ids-layout-grid-rows-md-16,
  .ids-layout-grid:not([enable-container])[rows-md="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="17"], :host(:not([enable-container])).ids-layout-grid-rows-md-17,
  .ids-layout-grid:not([enable-container])[rows-md="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="18"], :host(:not([enable-container])).ids-layout-grid-rows-md-18,
  .ids-layout-grid:not([enable-container])[rows-md="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="19"], :host(:not([enable-container])).ids-layout-grid-rows-md-19,
  .ids-layout-grid:not([enable-container])[rows-md="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="20"], :host(:not([enable-container])).ids-layout-grid-rows-md-20,
  .ids-layout-grid:not([enable-container])[rows-md="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="21"], :host(:not([enable-container])).ids-layout-grid-rows-md-21,
  .ids-layout-grid:not([enable-container])[rows-md="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="22"], :host(:not([enable-container])).ids-layout-grid-rows-md-22,
  .ids-layout-grid:not([enable-container])[rows-md="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="23"], :host(:not([enable-container])).ids-layout-grid-rows-md-23,
  .ids-layout-grid:not([enable-container])[rows-md="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="24"], :host(:not([enable-container])).ids-layout-grid-rows-md-24,
  .ids-layout-grid:not([enable-container])[rows-md="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="25"], :host(:not([enable-container])).ids-layout-grid-rows-md-25,
  .ids-layout-grid:not([enable-container])[rows-md="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="26"], :host(:not([enable-container])).ids-layout-grid-rows-md-26,
  .ids-layout-grid:not([enable-container])[rows-md="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="27"], :host(:not([enable-container])).ids-layout-grid-rows-md-27,
  .ids-layout-grid:not([enable-container])[rows-md="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="28"], :host(:not([enable-container])).ids-layout-grid-rows-md-28,
  .ids-layout-grid:not([enable-container])[rows-md="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="29"], :host(:not([enable-container])).ids-layout-grid-rows-md-29,
  .ids-layout-grid:not([enable-container])[rows-md="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="30"], :host(:not([enable-container])).ids-layout-grid-rows-md-30,
  .ids-layout-grid:not([enable-container])[rows-md="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="31"], :host(:not([enable-container])).ids-layout-grid-rows-md-31,
  .ids-layout-grid:not([enable-container])[rows-md="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="32"], :host(:not([enable-container])).ids-layout-grid-rows-md-32,
  .ids-layout-grid:not([enable-container])[rows-md="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="33"], :host(:not([enable-container])).ids-layout-grid-rows-md-33,
  .ids-layout-grid:not([enable-container])[rows-md="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="34"], :host(:not([enable-container])).ids-layout-grid-rows-md-34,
  .ids-layout-grid:not([enable-container])[rows-md="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="35"], :host(:not([enable-container])).ids-layout-grid-rows-md-35,
  .ids-layout-grid:not([enable-container])[rows-md="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="36"], :host(:not([enable-container])).ids-layout-grid-rows-md-36,
  .ids-layout-grid:not([enable-container])[rows-md="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="37"], :host(:not([enable-container])).ids-layout-grid-rows-md-37,
  .ids-layout-grid:not([enable-container])[rows-md="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="38"], :host(:not([enable-container])).ids-layout-grid-rows-md-38,
  .ids-layout-grid:not([enable-container])[rows-md="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="39"], :host(:not([enable-container])).ids-layout-grid-rows-md-39,
  .ids-layout-grid:not([enable-container])[rows-md="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="40"], :host(:not([enable-container])).ids-layout-grid-rows-md-40,
  .ids-layout-grid:not([enable-container])[rows-md="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="41"], :host(:not([enable-container])).ids-layout-grid-rows-md-41,
  .ids-layout-grid:not([enable-container])[rows-md="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="42"], :host(:not([enable-container])).ids-layout-grid-rows-md-42,
  .ids-layout-grid:not([enable-container])[rows-md="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="43"], :host(:not([enable-container])).ids-layout-grid-rows-md-43,
  .ids-layout-grid:not([enable-container])[rows-md="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="44"], :host(:not([enable-container])).ids-layout-grid-rows-md-44,
  .ids-layout-grid:not([enable-container])[rows-md="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="45"], :host(:not([enable-container])).ids-layout-grid-rows-md-45,
  .ids-layout-grid:not([enable-container])[rows-md="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="46"], :host(:not([enable-container])).ids-layout-grid-rows-md-46,
  .ids-layout-grid:not([enable-container])[rows-md="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="47"], :host(:not([enable-container])).ids-layout-grid-rows-md-47,
  .ids-layout-grid:not([enable-container])[rows-md="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="48"], :host(:not([enable-container])).ids-layout-grid-rows-md-48,
  .ids-layout-grid:not([enable-container])[rows-md="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="49"], :host(:not([enable-container])).ids-layout-grid-rows-md-49,
  .ids-layout-grid:not([enable-container])[rows-md="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="50"], :host(:not([enable-container])).ids-layout-grid-rows-md-50,
  .ids-layout-grid:not([enable-container])[rows-md="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=md]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=md]) {
    display: block;
  }
}
@media (width >= 928px) {
  :host(:not([enable-container])) > ::slotted([col-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-lg="1"], :host(:not([enable-container])).ids-layout-grid-rows-lg-1,
  .ids-layout-grid:not([enable-container])[rows-lg="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="2"], :host(:not([enable-container])).ids-layout-grid-rows-lg-2,
  .ids-layout-grid:not([enable-container])[rows-lg="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="3"], :host(:not([enable-container])).ids-layout-grid-rows-lg-3,
  .ids-layout-grid:not([enable-container])[rows-lg="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="4"], :host(:not([enable-container])).ids-layout-grid-rows-lg-4,
  .ids-layout-grid:not([enable-container])[rows-lg="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="5"], :host(:not([enable-container])).ids-layout-grid-rows-lg-5,
  .ids-layout-grid:not([enable-container])[rows-lg="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="6"], :host(:not([enable-container])).ids-layout-grid-rows-lg-6,
  .ids-layout-grid:not([enable-container])[rows-lg="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="7"], :host(:not([enable-container])).ids-layout-grid-rows-lg-7,
  .ids-layout-grid:not([enable-container])[rows-lg="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="8"], :host(:not([enable-container])).ids-layout-grid-rows-lg-8,
  .ids-layout-grid:not([enable-container])[rows-lg="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="9"], :host(:not([enable-container])).ids-layout-grid-rows-lg-9,
  .ids-layout-grid:not([enable-container])[rows-lg="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="10"], :host(:not([enable-container])).ids-layout-grid-rows-lg-10,
  .ids-layout-grid:not([enable-container])[rows-lg="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="11"], :host(:not([enable-container])).ids-layout-grid-rows-lg-11,
  .ids-layout-grid:not([enable-container])[rows-lg="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="12"], :host(:not([enable-container])).ids-layout-grid-rows-lg-12,
  .ids-layout-grid:not([enable-container])[rows-lg="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="13"], :host(:not([enable-container])).ids-layout-grid-rows-lg-13,
  .ids-layout-grid:not([enable-container])[rows-lg="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="14"], :host(:not([enable-container])).ids-layout-grid-rows-lg-14,
  .ids-layout-grid:not([enable-container])[rows-lg="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="15"], :host(:not([enable-container])).ids-layout-grid-rows-lg-15,
  .ids-layout-grid:not([enable-container])[rows-lg="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="16"], :host(:not([enable-container])).ids-layout-grid-rows-lg-16,
  .ids-layout-grid:not([enable-container])[rows-lg="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="17"], :host(:not([enable-container])).ids-layout-grid-rows-lg-17,
  .ids-layout-grid:not([enable-container])[rows-lg="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="18"], :host(:not([enable-container])).ids-layout-grid-rows-lg-18,
  .ids-layout-grid:not([enable-container])[rows-lg="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="19"], :host(:not([enable-container])).ids-layout-grid-rows-lg-19,
  .ids-layout-grid:not([enable-container])[rows-lg="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="20"], :host(:not([enable-container])).ids-layout-grid-rows-lg-20,
  .ids-layout-grid:not([enable-container])[rows-lg="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="21"], :host(:not([enable-container])).ids-layout-grid-rows-lg-21,
  .ids-layout-grid:not([enable-container])[rows-lg="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="22"], :host(:not([enable-container])).ids-layout-grid-rows-lg-22,
  .ids-layout-grid:not([enable-container])[rows-lg="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="23"], :host(:not([enable-container])).ids-layout-grid-rows-lg-23,
  .ids-layout-grid:not([enable-container])[rows-lg="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="24"], :host(:not([enable-container])).ids-layout-grid-rows-lg-24,
  .ids-layout-grid:not([enable-container])[rows-lg="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="25"], :host(:not([enable-container])).ids-layout-grid-rows-lg-25,
  .ids-layout-grid:not([enable-container])[rows-lg="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="26"], :host(:not([enable-container])).ids-layout-grid-rows-lg-26,
  .ids-layout-grid:not([enable-container])[rows-lg="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="27"], :host(:not([enable-container])).ids-layout-grid-rows-lg-27,
  .ids-layout-grid:not([enable-container])[rows-lg="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="28"], :host(:not([enable-container])).ids-layout-grid-rows-lg-28,
  .ids-layout-grid:not([enable-container])[rows-lg="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="29"], :host(:not([enable-container])).ids-layout-grid-rows-lg-29,
  .ids-layout-grid:not([enable-container])[rows-lg="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="30"], :host(:not([enable-container])).ids-layout-grid-rows-lg-30,
  .ids-layout-grid:not([enable-container])[rows-lg="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="31"], :host(:not([enable-container])).ids-layout-grid-rows-lg-31,
  .ids-layout-grid:not([enable-container])[rows-lg="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="32"], :host(:not([enable-container])).ids-layout-grid-rows-lg-32,
  .ids-layout-grid:not([enable-container])[rows-lg="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="33"], :host(:not([enable-container])).ids-layout-grid-rows-lg-33,
  .ids-layout-grid:not([enable-container])[rows-lg="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="34"], :host(:not([enable-container])).ids-layout-grid-rows-lg-34,
  .ids-layout-grid:not([enable-container])[rows-lg="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="35"], :host(:not([enable-container])).ids-layout-grid-rows-lg-35,
  .ids-layout-grid:not([enable-container])[rows-lg="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="36"], :host(:not([enable-container])).ids-layout-grid-rows-lg-36,
  .ids-layout-grid:not([enable-container])[rows-lg="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="37"], :host(:not([enable-container])).ids-layout-grid-rows-lg-37,
  .ids-layout-grid:not([enable-container])[rows-lg="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="38"], :host(:not([enable-container])).ids-layout-grid-rows-lg-38,
  .ids-layout-grid:not([enable-container])[rows-lg="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="39"], :host(:not([enable-container])).ids-layout-grid-rows-lg-39,
  .ids-layout-grid:not([enable-container])[rows-lg="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="40"], :host(:not([enable-container])).ids-layout-grid-rows-lg-40,
  .ids-layout-grid:not([enable-container])[rows-lg="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="41"], :host(:not([enable-container])).ids-layout-grid-rows-lg-41,
  .ids-layout-grid:not([enable-container])[rows-lg="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="42"], :host(:not([enable-container])).ids-layout-grid-rows-lg-42,
  .ids-layout-grid:not([enable-container])[rows-lg="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="43"], :host(:not([enable-container])).ids-layout-grid-rows-lg-43,
  .ids-layout-grid:not([enable-container])[rows-lg="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="44"], :host(:not([enable-container])).ids-layout-grid-rows-lg-44,
  .ids-layout-grid:not([enable-container])[rows-lg="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="45"], :host(:not([enable-container])).ids-layout-grid-rows-lg-45,
  .ids-layout-grid:not([enable-container])[rows-lg="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="46"], :host(:not([enable-container])).ids-layout-grid-rows-lg-46,
  .ids-layout-grid:not([enable-container])[rows-lg="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="47"], :host(:not([enable-container])).ids-layout-grid-rows-lg-47,
  .ids-layout-grid:not([enable-container])[rows-lg="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="48"], :host(:not([enable-container])).ids-layout-grid-rows-lg-48,
  .ids-layout-grid:not([enable-container])[rows-lg="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="49"], :host(:not([enable-container])).ids-layout-grid-rows-lg-49,
  .ids-layout-grid:not([enable-container])[rows-lg="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="50"], :host(:not([enable-container])).ids-layout-grid-rows-lg-50,
  .ids-layout-grid:not([enable-container])[rows-lg="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=lg]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=lg]) {
    display: block;
  }
}
@media (width >= 1183px) {
  :host(:not([enable-container])) > ::slotted([col-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xl-1,
  .ids-layout-grid:not([enable-container])[rows-xl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xl-2,
  .ids-layout-grid:not([enable-container])[rows-xl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xl-3,
  .ids-layout-grid:not([enable-container])[rows-xl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xl-4,
  .ids-layout-grid:not([enable-container])[rows-xl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xl-5,
  .ids-layout-grid:not([enable-container])[rows-xl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xl-6,
  .ids-layout-grid:not([enable-container])[rows-xl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xl-7,
  .ids-layout-grid:not([enable-container])[rows-xl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xl-8,
  .ids-layout-grid:not([enable-container])[rows-xl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xl-9,
  .ids-layout-grid:not([enable-container])[rows-xl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xl-10,
  .ids-layout-grid:not([enable-container])[rows-xl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xl-11,
  .ids-layout-grid:not([enable-container])[rows-xl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xl-12,
  .ids-layout-grid:not([enable-container])[rows-xl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xl-13,
  .ids-layout-grid:not([enable-container])[rows-xl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xl-14,
  .ids-layout-grid:not([enable-container])[rows-xl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xl-15,
  .ids-layout-grid:not([enable-container])[rows-xl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xl-16,
  .ids-layout-grid:not([enable-container])[rows-xl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xl-17,
  .ids-layout-grid:not([enable-container])[rows-xl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xl-18,
  .ids-layout-grid:not([enable-container])[rows-xl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xl-19,
  .ids-layout-grid:not([enable-container])[rows-xl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xl-20,
  .ids-layout-grid:not([enable-container])[rows-xl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xl-21,
  .ids-layout-grid:not([enable-container])[rows-xl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xl-22,
  .ids-layout-grid:not([enable-container])[rows-xl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xl-23,
  .ids-layout-grid:not([enable-container])[rows-xl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xl-24,
  .ids-layout-grid:not([enable-container])[rows-xl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xl-25,
  .ids-layout-grid:not([enable-container])[rows-xl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xl-26,
  .ids-layout-grid:not([enable-container])[rows-xl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xl-27,
  .ids-layout-grid:not([enable-container])[rows-xl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xl-28,
  .ids-layout-grid:not([enable-container])[rows-xl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xl-29,
  .ids-layout-grid:not([enable-container])[rows-xl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xl-30,
  .ids-layout-grid:not([enable-container])[rows-xl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xl-31,
  .ids-layout-grid:not([enable-container])[rows-xl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xl-32,
  .ids-layout-grid:not([enable-container])[rows-xl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xl-33,
  .ids-layout-grid:not([enable-container])[rows-xl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xl-34,
  .ids-layout-grid:not([enable-container])[rows-xl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xl-35,
  .ids-layout-grid:not([enable-container])[rows-xl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xl-36,
  .ids-layout-grid:not([enable-container])[rows-xl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xl-37,
  .ids-layout-grid:not([enable-container])[rows-xl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xl-38,
  .ids-layout-grid:not([enable-container])[rows-xl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xl-39,
  .ids-layout-grid:not([enable-container])[rows-xl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xl-40,
  .ids-layout-grid:not([enable-container])[rows-xl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xl-41,
  .ids-layout-grid:not([enable-container])[rows-xl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xl-42,
  .ids-layout-grid:not([enable-container])[rows-xl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xl-43,
  .ids-layout-grid:not([enable-container])[rows-xl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xl-44,
  .ids-layout-grid:not([enable-container])[rows-xl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xl-45,
  .ids-layout-grid:not([enable-container])[rows-xl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xl-46,
  .ids-layout-grid:not([enable-container])[rows-xl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xl-47,
  .ids-layout-grid:not([enable-container])[rows-xl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xl-48,
  .ids-layout-grid:not([enable-container])[rows-xl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xl-49,
  .ids-layout-grid:not([enable-container])[rows-xl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xl-50,
  .ids-layout-grid:not([enable-container])[rows-xl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xl]) {
    display: block;
  }
}
@media (width >= 2463px) {
  :host(:not([enable-container])) > ::slotted([col-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xxl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid:not([enable-container])[rows-xxl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid:not([enable-container])[rows-xxl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid:not([enable-container])[rows-xxl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid:not([enable-container])[rows-xxl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid:not([enable-container])[rows-xxl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid:not([enable-container])[rows-xxl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid:not([enable-container])[rows-xxl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid:not([enable-container])[rows-xxl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid:not([enable-container])[rows-xxl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid:not([enable-container])[rows-xxl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid:not([enable-container])[rows-xxl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid:not([enable-container])[rows-xxl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid:not([enable-container])[rows-xxl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid:not([enable-container])[rows-xxl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid:not([enable-container])[rows-xxl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid:not([enable-container])[rows-xxl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid:not([enable-container])[rows-xxl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid:not([enable-container])[rows-xxl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid:not([enable-container])[rows-xxl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid:not([enable-container])[rows-xxl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid:not([enable-container])[rows-xxl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid:not([enable-container])[rows-xxl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid:not([enable-container])[rows-xxl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid:not([enable-container])[rows-xxl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid:not([enable-container])[rows-xxl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid:not([enable-container])[rows-xxl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid:not([enable-container])[rows-xxl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid:not([enable-container])[rows-xxl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid:not([enable-container])[rows-xxl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid:not([enable-container])[rows-xxl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid:not([enable-container])[rows-xxl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid:not([enable-container])[rows-xxl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid:not([enable-container])[rows-xxl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid:not([enable-container])[rows-xxl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid:not([enable-container])[rows-xxl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid:not([enable-container])[rows-xxl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid:not([enable-container])[rows-xxl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid:not([enable-container])[rows-xxl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid:not([enable-container])[rows-xxl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid:not([enable-container])[rows-xxl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid:not([enable-container])[rows-xxl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid:not([enable-container])[rows-xxl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid:not([enable-container])[rows-xxl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid:not([enable-container])[rows-xxl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid:not([enable-container])[rows-xxl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid:not([enable-container])[rows-xxl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid:not([enable-container])[rows-xxl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid:not([enable-container])[rows-xxl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid:not([enable-container])[rows-xxl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid:not([enable-container])[rows-xxl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xxl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Use container queries if enabled */
:host([enable-container]),
.ids-layout-grid[enable-container] {
  container-type: inline-size;
}
@container (width >= 320px) {
  :host([enable-container]) > ::slotted([col-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xs="1"], :host([enable-container]).ids-layout-grid-rows-xs-1,
  .ids-layout-grid[enable-container][rows-xs="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="2"], :host([enable-container]).ids-layout-grid-rows-xs-2,
  .ids-layout-grid[enable-container][rows-xs="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="3"], :host([enable-container]).ids-layout-grid-rows-xs-3,
  .ids-layout-grid[enable-container][rows-xs="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="4"], :host([enable-container]).ids-layout-grid-rows-xs-4,
  .ids-layout-grid[enable-container][rows-xs="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="5"], :host([enable-container]).ids-layout-grid-rows-xs-5,
  .ids-layout-grid[enable-container][rows-xs="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="6"], :host([enable-container]).ids-layout-grid-rows-xs-6,
  .ids-layout-grid[enable-container][rows-xs="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="7"], :host([enable-container]).ids-layout-grid-rows-xs-7,
  .ids-layout-grid[enable-container][rows-xs="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="8"], :host([enable-container]).ids-layout-grid-rows-xs-8,
  .ids-layout-grid[enable-container][rows-xs="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="9"], :host([enable-container]).ids-layout-grid-rows-xs-9,
  .ids-layout-grid[enable-container][rows-xs="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="10"], :host([enable-container]).ids-layout-grid-rows-xs-10,
  .ids-layout-grid[enable-container][rows-xs="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="11"], :host([enable-container]).ids-layout-grid-rows-xs-11,
  .ids-layout-grid[enable-container][rows-xs="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="12"], :host([enable-container]).ids-layout-grid-rows-xs-12,
  .ids-layout-grid[enable-container][rows-xs="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="13"], :host([enable-container]).ids-layout-grid-rows-xs-13,
  .ids-layout-grid[enable-container][rows-xs="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="14"], :host([enable-container]).ids-layout-grid-rows-xs-14,
  .ids-layout-grid[enable-container][rows-xs="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="15"], :host([enable-container]).ids-layout-grid-rows-xs-15,
  .ids-layout-grid[enable-container][rows-xs="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="16"], :host([enable-container]).ids-layout-grid-rows-xs-16,
  .ids-layout-grid[enable-container][rows-xs="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="17"], :host([enable-container]).ids-layout-grid-rows-xs-17,
  .ids-layout-grid[enable-container][rows-xs="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="18"], :host([enable-container]).ids-layout-grid-rows-xs-18,
  .ids-layout-grid[enable-container][rows-xs="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="19"], :host([enable-container]).ids-layout-grid-rows-xs-19,
  .ids-layout-grid[enable-container][rows-xs="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="20"], :host([enable-container]).ids-layout-grid-rows-xs-20,
  .ids-layout-grid[enable-container][rows-xs="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="21"], :host([enable-container]).ids-layout-grid-rows-xs-21,
  .ids-layout-grid[enable-container][rows-xs="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="22"], :host([enable-container]).ids-layout-grid-rows-xs-22,
  .ids-layout-grid[enable-container][rows-xs="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="23"], :host([enable-container]).ids-layout-grid-rows-xs-23,
  .ids-layout-grid[enable-container][rows-xs="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="24"], :host([enable-container]).ids-layout-grid-rows-xs-24,
  .ids-layout-grid[enable-container][rows-xs="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="25"], :host([enable-container]).ids-layout-grid-rows-xs-25,
  .ids-layout-grid[enable-container][rows-xs="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="26"], :host([enable-container]).ids-layout-grid-rows-xs-26,
  .ids-layout-grid[enable-container][rows-xs="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="27"], :host([enable-container]).ids-layout-grid-rows-xs-27,
  .ids-layout-grid[enable-container][rows-xs="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="28"], :host([enable-container]).ids-layout-grid-rows-xs-28,
  .ids-layout-grid[enable-container][rows-xs="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="29"], :host([enable-container]).ids-layout-grid-rows-xs-29,
  .ids-layout-grid[enable-container][rows-xs="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="30"], :host([enable-container]).ids-layout-grid-rows-xs-30,
  .ids-layout-grid[enable-container][rows-xs="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="31"], :host([enable-container]).ids-layout-grid-rows-xs-31,
  .ids-layout-grid[enable-container][rows-xs="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="32"], :host([enable-container]).ids-layout-grid-rows-xs-32,
  .ids-layout-grid[enable-container][rows-xs="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="33"], :host([enable-container]).ids-layout-grid-rows-xs-33,
  .ids-layout-grid[enable-container][rows-xs="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="34"], :host([enable-container]).ids-layout-grid-rows-xs-34,
  .ids-layout-grid[enable-container][rows-xs="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="35"], :host([enable-container]).ids-layout-grid-rows-xs-35,
  .ids-layout-grid[enable-container][rows-xs="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="36"], :host([enable-container]).ids-layout-grid-rows-xs-36,
  .ids-layout-grid[enable-container][rows-xs="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="37"], :host([enable-container]).ids-layout-grid-rows-xs-37,
  .ids-layout-grid[enable-container][rows-xs="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="38"], :host([enable-container]).ids-layout-grid-rows-xs-38,
  .ids-layout-grid[enable-container][rows-xs="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="39"], :host([enable-container]).ids-layout-grid-rows-xs-39,
  .ids-layout-grid[enable-container][rows-xs="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="40"], :host([enable-container]).ids-layout-grid-rows-xs-40,
  .ids-layout-grid[enable-container][rows-xs="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="41"], :host([enable-container]).ids-layout-grid-rows-xs-41,
  .ids-layout-grid[enable-container][rows-xs="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="42"], :host([enable-container]).ids-layout-grid-rows-xs-42,
  .ids-layout-grid[enable-container][rows-xs="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="43"], :host([enable-container]).ids-layout-grid-rows-xs-43,
  .ids-layout-grid[enable-container][rows-xs="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="44"], :host([enable-container]).ids-layout-grid-rows-xs-44,
  .ids-layout-grid[enable-container][rows-xs="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="45"], :host([enable-container]).ids-layout-grid-rows-xs-45,
  .ids-layout-grid[enable-container][rows-xs="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="46"], :host([enable-container]).ids-layout-grid-rows-xs-46,
  .ids-layout-grid[enable-container][rows-xs="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="47"], :host([enable-container]).ids-layout-grid-rows-xs-47,
  .ids-layout-grid[enable-container][rows-xs="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="48"], :host([enable-container]).ids-layout-grid-rows-xs-48,
  .ids-layout-grid[enable-container][rows-xs="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="49"], :host([enable-container]).ids-layout-grid-rows-xs-49,
  .ids-layout-grid[enable-container][rows-xs="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="50"], :host([enable-container]).ids-layout-grid-rows-xs-50,
  .ids-layout-grid[enable-container][rows-xs="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xs]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xs]) {
    display: block;
  }
}
@container (width >= 767px) {
  :host([enable-container]) > ::slotted([col-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-sm="1"], :host([enable-container]).ids-layout-grid-rows-sm-1,
  .ids-layout-grid[enable-container][rows-sm="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="2"], :host([enable-container]).ids-layout-grid-rows-sm-2,
  .ids-layout-grid[enable-container][rows-sm="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="3"], :host([enable-container]).ids-layout-grid-rows-sm-3,
  .ids-layout-grid[enable-container][rows-sm="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="4"], :host([enable-container]).ids-layout-grid-rows-sm-4,
  .ids-layout-grid[enable-container][rows-sm="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="5"], :host([enable-container]).ids-layout-grid-rows-sm-5,
  .ids-layout-grid[enable-container][rows-sm="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="6"], :host([enable-container]).ids-layout-grid-rows-sm-6,
  .ids-layout-grid[enable-container][rows-sm="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="7"], :host([enable-container]).ids-layout-grid-rows-sm-7,
  .ids-layout-grid[enable-container][rows-sm="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="8"], :host([enable-container]).ids-layout-grid-rows-sm-8,
  .ids-layout-grid[enable-container][rows-sm="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="9"], :host([enable-container]).ids-layout-grid-rows-sm-9,
  .ids-layout-grid[enable-container][rows-sm="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="10"], :host([enable-container]).ids-layout-grid-rows-sm-10,
  .ids-layout-grid[enable-container][rows-sm="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="11"], :host([enable-container]).ids-layout-grid-rows-sm-11,
  .ids-layout-grid[enable-container][rows-sm="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="12"], :host([enable-container]).ids-layout-grid-rows-sm-12,
  .ids-layout-grid[enable-container][rows-sm="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="13"], :host([enable-container]).ids-layout-grid-rows-sm-13,
  .ids-layout-grid[enable-container][rows-sm="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="14"], :host([enable-container]).ids-layout-grid-rows-sm-14,
  .ids-layout-grid[enable-container][rows-sm="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="15"], :host([enable-container]).ids-layout-grid-rows-sm-15,
  .ids-layout-grid[enable-container][rows-sm="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="16"], :host([enable-container]).ids-layout-grid-rows-sm-16,
  .ids-layout-grid[enable-container][rows-sm="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="17"], :host([enable-container]).ids-layout-grid-rows-sm-17,
  .ids-layout-grid[enable-container][rows-sm="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="18"], :host([enable-container]).ids-layout-grid-rows-sm-18,
  .ids-layout-grid[enable-container][rows-sm="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="19"], :host([enable-container]).ids-layout-grid-rows-sm-19,
  .ids-layout-grid[enable-container][rows-sm="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="20"], :host([enable-container]).ids-layout-grid-rows-sm-20,
  .ids-layout-grid[enable-container][rows-sm="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="21"], :host([enable-container]).ids-layout-grid-rows-sm-21,
  .ids-layout-grid[enable-container][rows-sm="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="22"], :host([enable-container]).ids-layout-grid-rows-sm-22,
  .ids-layout-grid[enable-container][rows-sm="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="23"], :host([enable-container]).ids-layout-grid-rows-sm-23,
  .ids-layout-grid[enable-container][rows-sm="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="24"], :host([enable-container]).ids-layout-grid-rows-sm-24,
  .ids-layout-grid[enable-container][rows-sm="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="25"], :host([enable-container]).ids-layout-grid-rows-sm-25,
  .ids-layout-grid[enable-container][rows-sm="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="26"], :host([enable-container]).ids-layout-grid-rows-sm-26,
  .ids-layout-grid[enable-container][rows-sm="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="27"], :host([enable-container]).ids-layout-grid-rows-sm-27,
  .ids-layout-grid[enable-container][rows-sm="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="28"], :host([enable-container]).ids-layout-grid-rows-sm-28,
  .ids-layout-grid[enable-container][rows-sm="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="29"], :host([enable-container]).ids-layout-grid-rows-sm-29,
  .ids-layout-grid[enable-container][rows-sm="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="30"], :host([enable-container]).ids-layout-grid-rows-sm-30,
  .ids-layout-grid[enable-container][rows-sm="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="31"], :host([enable-container]).ids-layout-grid-rows-sm-31,
  .ids-layout-grid[enable-container][rows-sm="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="32"], :host([enable-container]).ids-layout-grid-rows-sm-32,
  .ids-layout-grid[enable-container][rows-sm="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="33"], :host([enable-container]).ids-layout-grid-rows-sm-33,
  .ids-layout-grid[enable-container][rows-sm="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="34"], :host([enable-container]).ids-layout-grid-rows-sm-34,
  .ids-layout-grid[enable-container][rows-sm="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="35"], :host([enable-container]).ids-layout-grid-rows-sm-35,
  .ids-layout-grid[enable-container][rows-sm="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="36"], :host([enable-container]).ids-layout-grid-rows-sm-36,
  .ids-layout-grid[enable-container][rows-sm="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="37"], :host([enable-container]).ids-layout-grid-rows-sm-37,
  .ids-layout-grid[enable-container][rows-sm="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="38"], :host([enable-container]).ids-layout-grid-rows-sm-38,
  .ids-layout-grid[enable-container][rows-sm="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="39"], :host([enable-container]).ids-layout-grid-rows-sm-39,
  .ids-layout-grid[enable-container][rows-sm="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="40"], :host([enable-container]).ids-layout-grid-rows-sm-40,
  .ids-layout-grid[enable-container][rows-sm="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="41"], :host([enable-container]).ids-layout-grid-rows-sm-41,
  .ids-layout-grid[enable-container][rows-sm="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="42"], :host([enable-container]).ids-layout-grid-rows-sm-42,
  .ids-layout-grid[enable-container][rows-sm="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="43"], :host([enable-container]).ids-layout-grid-rows-sm-43,
  .ids-layout-grid[enable-container][rows-sm="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="44"], :host([enable-container]).ids-layout-grid-rows-sm-44,
  .ids-layout-grid[enable-container][rows-sm="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="45"], :host([enable-container]).ids-layout-grid-rows-sm-45,
  .ids-layout-grid[enable-container][rows-sm="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="46"], :host([enable-container]).ids-layout-grid-rows-sm-46,
  .ids-layout-grid[enable-container][rows-sm="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="47"], :host([enable-container]).ids-layout-grid-rows-sm-47,
  .ids-layout-grid[enable-container][rows-sm="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="48"], :host([enable-container]).ids-layout-grid-rows-sm-48,
  .ids-layout-grid[enable-container][rows-sm="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="49"], :host([enable-container]).ids-layout-grid-rows-sm-49,
  .ids-layout-grid[enable-container][rows-sm="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="50"], :host([enable-container]).ids-layout-grid-rows-sm-50,
  .ids-layout-grid[enable-container][rows-sm="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=sm]),
  .ids-layout-grid[enable-container] > ::slotted([hide=sm]) {
    display: block;
  }
}
@container (width >= 927px) {
  :host([enable-container]) > ::slotted([col-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-md="1"], :host([enable-container]).ids-layout-grid-rows-md-1,
  .ids-layout-grid[enable-container][rows-md="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="2"], :host([enable-container]).ids-layout-grid-rows-md-2,
  .ids-layout-grid[enable-container][rows-md="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid[enable-container] > ::slotted([order-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="3"], :host([enable-container]).ids-layout-grid-rows-md-3,
  .ids-layout-grid[enable-container][rows-md="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid[enable-container] > ::slotted([order-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="4"], :host([enable-container]).ids-layout-grid-rows-md-4,
  .ids-layout-grid[enable-container][rows-md="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid[enable-container] > ::slotted([order-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="5"], :host([enable-container]).ids-layout-grid-rows-md-5,
  .ids-layout-grid[enable-container][rows-md="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid[enable-container] > ::slotted([order-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="6"], :host([enable-container]).ids-layout-grid-rows-md-6,
  .ids-layout-grid[enable-container][rows-md="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid[enable-container] > ::slotted([order-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="7"], :host([enable-container]).ids-layout-grid-rows-md-7,
  .ids-layout-grid[enable-container][rows-md="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid[enable-container] > ::slotted([order-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="8"], :host([enable-container]).ids-layout-grid-rows-md-8,
  .ids-layout-grid[enable-container][rows-md="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid[enable-container] > ::slotted([order-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="9"], :host([enable-container]).ids-layout-grid-rows-md-9,
  .ids-layout-grid[enable-container][rows-md="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid[enable-container] > ::slotted([order-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="10"], :host([enable-container]).ids-layout-grid-rows-md-10,
  .ids-layout-grid[enable-container][rows-md="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid[enable-container] > ::slotted([order-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="11"], :host([enable-container]).ids-layout-grid-rows-md-11,
  .ids-layout-grid[enable-container][rows-md="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid[enable-container] > ::slotted([order-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="12"], :host([enable-container]).ids-layout-grid-rows-md-12,
  .ids-layout-grid[enable-container][rows-md="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid[enable-container] > ::slotted([order-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="13"], :host([enable-container]).ids-layout-grid-rows-md-13,
  .ids-layout-grid[enable-container][rows-md="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid[enable-container] > ::slotted([order-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="14"], :host([enable-container]).ids-layout-grid-rows-md-14,
  .ids-layout-grid[enable-container][rows-md="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid[enable-container] > ::slotted([order-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="15"], :host([enable-container]).ids-layout-grid-rows-md-15,
  .ids-layout-grid[enable-container][rows-md="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid[enable-container] > ::slotted([order-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="16"], :host([enable-container]).ids-layout-grid-rows-md-16,
  .ids-layout-grid[enable-container][rows-md="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid[enable-container] > ::slotted([order-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="17"], :host([enable-container]).ids-layout-grid-rows-md-17,
  .ids-layout-grid[enable-container][rows-md="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid[enable-container] > ::slotted([order-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="18"], :host([enable-container]).ids-layout-grid-rows-md-18,
  .ids-layout-grid[enable-container][rows-md="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid[enable-container] > ::slotted([order-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="19"], :host([enable-container]).ids-layout-grid-rows-md-19,
  .ids-layout-grid[enable-container][rows-md="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid[enable-container] > ::slotted([order-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="20"], :host([enable-container]).ids-layout-grid-rows-md-20,
  .ids-layout-grid[enable-container][rows-md="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid[enable-container] > ::slotted([order-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="21"], :host([enable-container]).ids-layout-grid-rows-md-21,
  .ids-layout-grid[enable-container][rows-md="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid[enable-container] > ::slotted([order-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="22"], :host([enable-container]).ids-layout-grid-rows-md-22,
  .ids-layout-grid[enable-container][rows-md="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid[enable-container] > ::slotted([order-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="23"], :host([enable-container]).ids-layout-grid-rows-md-23,
  .ids-layout-grid[enable-container][rows-md="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid[enable-container] > ::slotted([order-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="24"], :host([enable-container]).ids-layout-grid-rows-md-24,
  .ids-layout-grid[enable-container][rows-md="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid[enable-container] > ::slotted([order-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="25"], :host([enable-container]).ids-layout-grid-rows-md-25,
  .ids-layout-grid[enable-container][rows-md="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid[enable-container] > ::slotted([order-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="26"], :host([enable-container]).ids-layout-grid-rows-md-26,
  .ids-layout-grid[enable-container][rows-md="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid[enable-container] > ::slotted([order-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="27"], :host([enable-container]).ids-layout-grid-rows-md-27,
  .ids-layout-grid[enable-container][rows-md="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid[enable-container] > ::slotted([order-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="28"], :host([enable-container]).ids-layout-grid-rows-md-28,
  .ids-layout-grid[enable-container][rows-md="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid[enable-container] > ::slotted([order-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="29"], :host([enable-container]).ids-layout-grid-rows-md-29,
  .ids-layout-grid[enable-container][rows-md="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid[enable-container] > ::slotted([order-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="30"], :host([enable-container]).ids-layout-grid-rows-md-30,
  .ids-layout-grid[enable-container][rows-md="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid[enable-container] > ::slotted([order-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="31"], :host([enable-container]).ids-layout-grid-rows-md-31,
  .ids-layout-grid[enable-container][rows-md="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid[enable-container] > ::slotted([order-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="32"], :host([enable-container]).ids-layout-grid-rows-md-32,
  .ids-layout-grid[enable-container][rows-md="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid[enable-container] > ::slotted([order-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="33"], :host([enable-container]).ids-layout-grid-rows-md-33,
  .ids-layout-grid[enable-container][rows-md="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid[enable-container] > ::slotted([order-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="34"], :host([enable-container]).ids-layout-grid-rows-md-34,
  .ids-layout-grid[enable-container][rows-md="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid[enable-container] > ::slotted([order-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="35"], :host([enable-container]).ids-layout-grid-rows-md-35,
  .ids-layout-grid[enable-container][rows-md="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid[enable-container] > ::slotted([order-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="36"], :host([enable-container]).ids-layout-grid-rows-md-36,
  .ids-layout-grid[enable-container][rows-md="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid[enable-container] > ::slotted([order-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="37"], :host([enable-container]).ids-layout-grid-rows-md-37,
  .ids-layout-grid[enable-container][rows-md="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid[enable-container] > ::slotted([order-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="38"], :host([enable-container]).ids-layout-grid-rows-md-38,
  .ids-layout-grid[enable-container][rows-md="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid[enable-container] > ::slotted([order-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="39"], :host([enable-container]).ids-layout-grid-rows-md-39,
  .ids-layout-grid[enable-container][rows-md="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid[enable-container] > ::slotted([order-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="40"], :host([enable-container]).ids-layout-grid-rows-md-40,
  .ids-layout-grid[enable-container][rows-md="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid[enable-container] > ::slotted([order-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="41"], :host([enable-container]).ids-layout-grid-rows-md-41,
  .ids-layout-grid[enable-container][rows-md="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid[enable-container] > ::slotted([order-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="42"], :host([enable-container]).ids-layout-grid-rows-md-42,
  .ids-layout-grid[enable-container][rows-md="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid[enable-container] > ::slotted([order-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="43"], :host([enable-container]).ids-layout-grid-rows-md-43,
  .ids-layout-grid[enable-container][rows-md="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid[enable-container] > ::slotted([order-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="44"], :host([enable-container]).ids-layout-grid-rows-md-44,
  .ids-layout-grid[enable-container][rows-md="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid[enable-container] > ::slotted([order-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="45"], :host([enable-container]).ids-layout-grid-rows-md-45,
  .ids-layout-grid[enable-container][rows-md="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid[enable-container] > ::slotted([order-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="46"], :host([enable-container]).ids-layout-grid-rows-md-46,
  .ids-layout-grid[enable-container][rows-md="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid[enable-container] > ::slotted([order-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="47"], :host([enable-container]).ids-layout-grid-rows-md-47,
  .ids-layout-grid[enable-container][rows-md="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid[enable-container] > ::slotted([order-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="48"], :host([enable-container]).ids-layout-grid-rows-md-48,
  .ids-layout-grid[enable-container][rows-md="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid[enable-container] > ::slotted([order-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="49"], :host([enable-container]).ids-layout-grid-rows-md-49,
  .ids-layout-grid[enable-container][rows-md="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid[enable-container] > ::slotted([order-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="50"], :host([enable-container]).ids-layout-grid-rows-md-50,
  .ids-layout-grid[enable-container][rows-md="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid[enable-container] > ::slotted([order-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=md]),
  .ids-layout-grid[enable-container] > ::slotted([hide=md]) {
    display: block;
  }
}
@container (width >= 928px) {
  :host([enable-container]) > ::slotted([col-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-lg="1"], :host([enable-container]).ids-layout-grid-rows-lg-1,
  .ids-layout-grid[enable-container][rows-lg="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="2"], :host([enable-container]).ids-layout-grid-rows-lg-2,
  .ids-layout-grid[enable-container][rows-lg="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="3"], :host([enable-container]).ids-layout-grid-rows-lg-3,
  .ids-layout-grid[enable-container][rows-lg="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="4"], :host([enable-container]).ids-layout-grid-rows-lg-4,
  .ids-layout-grid[enable-container][rows-lg="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="5"], :host([enable-container]).ids-layout-grid-rows-lg-5,
  .ids-layout-grid[enable-container][rows-lg="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="6"], :host([enable-container]).ids-layout-grid-rows-lg-6,
  .ids-layout-grid[enable-container][rows-lg="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="7"], :host([enable-container]).ids-layout-grid-rows-lg-7,
  .ids-layout-grid[enable-container][rows-lg="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="8"], :host([enable-container]).ids-layout-grid-rows-lg-8,
  .ids-layout-grid[enable-container][rows-lg="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="9"], :host([enable-container]).ids-layout-grid-rows-lg-9,
  .ids-layout-grid[enable-container][rows-lg="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="10"], :host([enable-container]).ids-layout-grid-rows-lg-10,
  .ids-layout-grid[enable-container][rows-lg="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="11"], :host([enable-container]).ids-layout-grid-rows-lg-11,
  .ids-layout-grid[enable-container][rows-lg="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="12"], :host([enable-container]).ids-layout-grid-rows-lg-12,
  .ids-layout-grid[enable-container][rows-lg="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="13"], :host([enable-container]).ids-layout-grid-rows-lg-13,
  .ids-layout-grid[enable-container][rows-lg="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="14"], :host([enable-container]).ids-layout-grid-rows-lg-14,
  .ids-layout-grid[enable-container][rows-lg="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="15"], :host([enable-container]).ids-layout-grid-rows-lg-15,
  .ids-layout-grid[enable-container][rows-lg="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="16"], :host([enable-container]).ids-layout-grid-rows-lg-16,
  .ids-layout-grid[enable-container][rows-lg="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="17"], :host([enable-container]).ids-layout-grid-rows-lg-17,
  .ids-layout-grid[enable-container][rows-lg="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="18"], :host([enable-container]).ids-layout-grid-rows-lg-18,
  .ids-layout-grid[enable-container][rows-lg="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="19"], :host([enable-container]).ids-layout-grid-rows-lg-19,
  .ids-layout-grid[enable-container][rows-lg="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="20"], :host([enable-container]).ids-layout-grid-rows-lg-20,
  .ids-layout-grid[enable-container][rows-lg="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="21"], :host([enable-container]).ids-layout-grid-rows-lg-21,
  .ids-layout-grid[enable-container][rows-lg="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="22"], :host([enable-container]).ids-layout-grid-rows-lg-22,
  .ids-layout-grid[enable-container][rows-lg="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="23"], :host([enable-container]).ids-layout-grid-rows-lg-23,
  .ids-layout-grid[enable-container][rows-lg="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="24"], :host([enable-container]).ids-layout-grid-rows-lg-24,
  .ids-layout-grid[enable-container][rows-lg="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="25"], :host([enable-container]).ids-layout-grid-rows-lg-25,
  .ids-layout-grid[enable-container][rows-lg="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="26"], :host([enable-container]).ids-layout-grid-rows-lg-26,
  .ids-layout-grid[enable-container][rows-lg="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="27"], :host([enable-container]).ids-layout-grid-rows-lg-27,
  .ids-layout-grid[enable-container][rows-lg="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="28"], :host([enable-container]).ids-layout-grid-rows-lg-28,
  .ids-layout-grid[enable-container][rows-lg="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="29"], :host([enable-container]).ids-layout-grid-rows-lg-29,
  .ids-layout-grid[enable-container][rows-lg="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="30"], :host([enable-container]).ids-layout-grid-rows-lg-30,
  .ids-layout-grid[enable-container][rows-lg="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="31"], :host([enable-container]).ids-layout-grid-rows-lg-31,
  .ids-layout-grid[enable-container][rows-lg="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="32"], :host([enable-container]).ids-layout-grid-rows-lg-32,
  .ids-layout-grid[enable-container][rows-lg="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="33"], :host([enable-container]).ids-layout-grid-rows-lg-33,
  .ids-layout-grid[enable-container][rows-lg="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="34"], :host([enable-container]).ids-layout-grid-rows-lg-34,
  .ids-layout-grid[enable-container][rows-lg="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="35"], :host([enable-container]).ids-layout-grid-rows-lg-35,
  .ids-layout-grid[enable-container][rows-lg="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="36"], :host([enable-container]).ids-layout-grid-rows-lg-36,
  .ids-layout-grid[enable-container][rows-lg="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="37"], :host([enable-container]).ids-layout-grid-rows-lg-37,
  .ids-layout-grid[enable-container][rows-lg="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="38"], :host([enable-container]).ids-layout-grid-rows-lg-38,
  .ids-layout-grid[enable-container][rows-lg="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="39"], :host([enable-container]).ids-layout-grid-rows-lg-39,
  .ids-layout-grid[enable-container][rows-lg="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="40"], :host([enable-container]).ids-layout-grid-rows-lg-40,
  .ids-layout-grid[enable-container][rows-lg="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="41"], :host([enable-container]).ids-layout-grid-rows-lg-41,
  .ids-layout-grid[enable-container][rows-lg="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="42"], :host([enable-container]).ids-layout-grid-rows-lg-42,
  .ids-layout-grid[enable-container][rows-lg="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="43"], :host([enable-container]).ids-layout-grid-rows-lg-43,
  .ids-layout-grid[enable-container][rows-lg="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="44"], :host([enable-container]).ids-layout-grid-rows-lg-44,
  .ids-layout-grid[enable-container][rows-lg="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="45"], :host([enable-container]).ids-layout-grid-rows-lg-45,
  .ids-layout-grid[enable-container][rows-lg="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="46"], :host([enable-container]).ids-layout-grid-rows-lg-46,
  .ids-layout-grid[enable-container][rows-lg="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="47"], :host([enable-container]).ids-layout-grid-rows-lg-47,
  .ids-layout-grid[enable-container][rows-lg="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="48"], :host([enable-container]).ids-layout-grid-rows-lg-48,
  .ids-layout-grid[enable-container][rows-lg="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="49"], :host([enable-container]).ids-layout-grid-rows-lg-49,
  .ids-layout-grid[enable-container][rows-lg="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="50"], :host([enable-container]).ids-layout-grid-rows-lg-50,
  .ids-layout-grid[enable-container][rows-lg="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=lg]),
  .ids-layout-grid[enable-container] > ::slotted([hide=lg]) {
    display: block;
  }
}
@container (width >= 1183px) {
  :host([enable-container]) > ::slotted([col-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xl="1"], :host([enable-container]).ids-layout-grid-rows-xl-1,
  .ids-layout-grid[enable-container][rows-xl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="2"], :host([enable-container]).ids-layout-grid-rows-xl-2,
  .ids-layout-grid[enable-container][rows-xl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="3"], :host([enable-container]).ids-layout-grid-rows-xl-3,
  .ids-layout-grid[enable-container][rows-xl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="4"], :host([enable-container]).ids-layout-grid-rows-xl-4,
  .ids-layout-grid[enable-container][rows-xl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="5"], :host([enable-container]).ids-layout-grid-rows-xl-5,
  .ids-layout-grid[enable-container][rows-xl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="6"], :host([enable-container]).ids-layout-grid-rows-xl-6,
  .ids-layout-grid[enable-container][rows-xl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="7"], :host([enable-container]).ids-layout-grid-rows-xl-7,
  .ids-layout-grid[enable-container][rows-xl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="8"], :host([enable-container]).ids-layout-grid-rows-xl-8,
  .ids-layout-grid[enable-container][rows-xl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="9"], :host([enable-container]).ids-layout-grid-rows-xl-9,
  .ids-layout-grid[enable-container][rows-xl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="10"], :host([enable-container]).ids-layout-grid-rows-xl-10,
  .ids-layout-grid[enable-container][rows-xl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="11"], :host([enable-container]).ids-layout-grid-rows-xl-11,
  .ids-layout-grid[enable-container][rows-xl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="12"], :host([enable-container]).ids-layout-grid-rows-xl-12,
  .ids-layout-grid[enable-container][rows-xl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="13"], :host([enable-container]).ids-layout-grid-rows-xl-13,
  .ids-layout-grid[enable-container][rows-xl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="14"], :host([enable-container]).ids-layout-grid-rows-xl-14,
  .ids-layout-grid[enable-container][rows-xl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="15"], :host([enable-container]).ids-layout-grid-rows-xl-15,
  .ids-layout-grid[enable-container][rows-xl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="16"], :host([enable-container]).ids-layout-grid-rows-xl-16,
  .ids-layout-grid[enable-container][rows-xl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="17"], :host([enable-container]).ids-layout-grid-rows-xl-17,
  .ids-layout-grid[enable-container][rows-xl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="18"], :host([enable-container]).ids-layout-grid-rows-xl-18,
  .ids-layout-grid[enable-container][rows-xl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="19"], :host([enable-container]).ids-layout-grid-rows-xl-19,
  .ids-layout-grid[enable-container][rows-xl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="20"], :host([enable-container]).ids-layout-grid-rows-xl-20,
  .ids-layout-grid[enable-container][rows-xl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="21"], :host([enable-container]).ids-layout-grid-rows-xl-21,
  .ids-layout-grid[enable-container][rows-xl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="22"], :host([enable-container]).ids-layout-grid-rows-xl-22,
  .ids-layout-grid[enable-container][rows-xl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="23"], :host([enable-container]).ids-layout-grid-rows-xl-23,
  .ids-layout-grid[enable-container][rows-xl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="24"], :host([enable-container]).ids-layout-grid-rows-xl-24,
  .ids-layout-grid[enable-container][rows-xl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="25"], :host([enable-container]).ids-layout-grid-rows-xl-25,
  .ids-layout-grid[enable-container][rows-xl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="26"], :host([enable-container]).ids-layout-grid-rows-xl-26,
  .ids-layout-grid[enable-container][rows-xl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="27"], :host([enable-container]).ids-layout-grid-rows-xl-27,
  .ids-layout-grid[enable-container][rows-xl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="28"], :host([enable-container]).ids-layout-grid-rows-xl-28,
  .ids-layout-grid[enable-container][rows-xl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="29"], :host([enable-container]).ids-layout-grid-rows-xl-29,
  .ids-layout-grid[enable-container][rows-xl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="30"], :host([enable-container]).ids-layout-grid-rows-xl-30,
  .ids-layout-grid[enable-container][rows-xl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="31"], :host([enable-container]).ids-layout-grid-rows-xl-31,
  .ids-layout-grid[enable-container][rows-xl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="32"], :host([enable-container]).ids-layout-grid-rows-xl-32,
  .ids-layout-grid[enable-container][rows-xl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="33"], :host([enable-container]).ids-layout-grid-rows-xl-33,
  .ids-layout-grid[enable-container][rows-xl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="34"], :host([enable-container]).ids-layout-grid-rows-xl-34,
  .ids-layout-grid[enable-container][rows-xl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="35"], :host([enable-container]).ids-layout-grid-rows-xl-35,
  .ids-layout-grid[enable-container][rows-xl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="36"], :host([enable-container]).ids-layout-grid-rows-xl-36,
  .ids-layout-grid[enable-container][rows-xl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="37"], :host([enable-container]).ids-layout-grid-rows-xl-37,
  .ids-layout-grid[enable-container][rows-xl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="38"], :host([enable-container]).ids-layout-grid-rows-xl-38,
  .ids-layout-grid[enable-container][rows-xl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="39"], :host([enable-container]).ids-layout-grid-rows-xl-39,
  .ids-layout-grid[enable-container][rows-xl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="40"], :host([enable-container]).ids-layout-grid-rows-xl-40,
  .ids-layout-grid[enable-container][rows-xl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="41"], :host([enable-container]).ids-layout-grid-rows-xl-41,
  .ids-layout-grid[enable-container][rows-xl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="42"], :host([enable-container]).ids-layout-grid-rows-xl-42,
  .ids-layout-grid[enable-container][rows-xl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="43"], :host([enable-container]).ids-layout-grid-rows-xl-43,
  .ids-layout-grid[enable-container][rows-xl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="44"], :host([enable-container]).ids-layout-grid-rows-xl-44,
  .ids-layout-grid[enable-container][rows-xl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="45"], :host([enable-container]).ids-layout-grid-rows-xl-45,
  .ids-layout-grid[enable-container][rows-xl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="46"], :host([enable-container]).ids-layout-grid-rows-xl-46,
  .ids-layout-grid[enable-container][rows-xl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="47"], :host([enable-container]).ids-layout-grid-rows-xl-47,
  .ids-layout-grid[enable-container][rows-xl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="48"], :host([enable-container]).ids-layout-grid-rows-xl-48,
  .ids-layout-grid[enable-container][rows-xl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="49"], :host([enable-container]).ids-layout-grid-rows-xl-49,
  .ids-layout-grid[enable-container][rows-xl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="50"], :host([enable-container]).ids-layout-grid-rows-xl-50,
  .ids-layout-grid[enable-container][rows-xl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xl]) {
    display: block;
  }
}
@container (width >= 2463px) {
  :host([enable-container]) > ::slotted([col-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xxl="1"], :host([enable-container]).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid[enable-container][rows-xxl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="2"], :host([enable-container]).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid[enable-container][rows-xxl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="3"], :host([enable-container]).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid[enable-container][rows-xxl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="4"], :host([enable-container]).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid[enable-container][rows-xxl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="5"], :host([enable-container]).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid[enable-container][rows-xxl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="6"], :host([enable-container]).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid[enable-container][rows-xxl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="7"], :host([enable-container]).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid[enable-container][rows-xxl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="8"], :host([enable-container]).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid[enable-container][rows-xxl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="9"], :host([enable-container]).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid[enable-container][rows-xxl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="10"], :host([enable-container]).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid[enable-container][rows-xxl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="11"], :host([enable-container]).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid[enable-container][rows-xxl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="12"], :host([enable-container]).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid[enable-container][rows-xxl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="13"], :host([enable-container]).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid[enable-container][rows-xxl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="14"], :host([enable-container]).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid[enable-container][rows-xxl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="15"], :host([enable-container]).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid[enable-container][rows-xxl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="16"], :host([enable-container]).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid[enable-container][rows-xxl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="17"], :host([enable-container]).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid[enable-container][rows-xxl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="18"], :host([enable-container]).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid[enable-container][rows-xxl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="19"], :host([enable-container]).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid[enable-container][rows-xxl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="20"], :host([enable-container]).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid[enable-container][rows-xxl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="21"], :host([enable-container]).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid[enable-container][rows-xxl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="22"], :host([enable-container]).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid[enable-container][rows-xxl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="23"], :host([enable-container]).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid[enable-container][rows-xxl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="24"], :host([enable-container]).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid[enable-container][rows-xxl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="25"], :host([enable-container]).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid[enable-container][rows-xxl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="26"], :host([enable-container]).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid[enable-container][rows-xxl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="27"], :host([enable-container]).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid[enable-container][rows-xxl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="28"], :host([enable-container]).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid[enable-container][rows-xxl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="29"], :host([enable-container]).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid[enable-container][rows-xxl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="30"], :host([enable-container]).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid[enable-container][rows-xxl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="31"], :host([enable-container]).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid[enable-container][rows-xxl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="32"], :host([enable-container]).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid[enable-container][rows-xxl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="33"], :host([enable-container]).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid[enable-container][rows-xxl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="34"], :host([enable-container]).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid[enable-container][rows-xxl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="35"], :host([enable-container]).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid[enable-container][rows-xxl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="36"], :host([enable-container]).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid[enable-container][rows-xxl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="37"], :host([enable-container]).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid[enable-container][rows-xxl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="38"], :host([enable-container]).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid[enable-container][rows-xxl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="39"], :host([enable-container]).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid[enable-container][rows-xxl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="40"], :host([enable-container]).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid[enable-container][rows-xxl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="41"], :host([enable-container]).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid[enable-container][rows-xxl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="42"], :host([enable-container]).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid[enable-container][rows-xxl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="43"], :host([enable-container]).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid[enable-container][rows-xxl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="44"], :host([enable-container]).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid[enable-container][rows-xxl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="45"], :host([enable-container]).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid[enable-container][rows-xxl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="46"], :host([enable-container]).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid[enable-container][rows-xxl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="47"], :host([enable-container]).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid[enable-container][rows-xxl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="48"], :host([enable-container]).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid[enable-container][rows-xxl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="49"], :host([enable-container]).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid[enable-container][rows-xxl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="50"], :host([enable-container]).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid[enable-container][rows-xxl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xxl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Grid Gaps */
:host([gap=none]),
.ids-layout-grid.ids-layout-grid-gap-none {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 0;
}

:host([gap=sm]),
.ids-layout-grid.ids-layout-grid-gap-sm {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

:host([gap=md]),
.ids-layout-grid.ids-layout-grid-gap-md {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

:host([gap=lg]),
.ids-layout-grid.ids-layout-grid-gap-lg {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

:host([gap=xl]),
.ids-layout-grid.ids-layout-grid-gap-xl {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

/* Grid Margins */
:host([margin=xs]),
.ids-layout-grid.ids-layout-grid-margin-xs {
  margin: 16px;
}

:host([margin=sm]),
.ids-layout-grid.ids-layout-grid-margin-sm {
  margin: 16px;
}

:host([margin=md]),
.ids-layout-grid.ids-layout-grid-margin-md {
  margin: 16px;
}

:host([margin=lg]),
.ids-layout-grid.ids-layout-grid-margin-lg {
  margin: 24px;
}

:host([margin=xl]),
.ids-layout-grid.ids-layout-grid-margin-xl {
  margin: 24px;
}

:host([margin=auto]),
.ids-layout-grid.ids-layout-grid-margin-auto {
  margin: auto;
}

/* Grid Margin Y */
:host([margin-y=xs]),
.ids-layout-grid.ids-layout-grid-margin-y-xs {
  margin-block: 16px;
}

:host([margin-y=sm]),
.ids-layout-grid.ids-layout-grid-margin-y-sm {
  margin-block: 16px;
}

:host([margin-y=md]),
.ids-layout-grid.ids-layout-grid-margin-y-md {
  margin-block: 16px;
}

:host([margin-y=lg]),
.ids-layout-grid.ids-layout-grid-margin-y-lg {
  margin-block: 24px;
}

:host([margin-y=xl]),
.ids-layout-grid.ids-layout-grid-margin-y-xl {
  margin-block: 24px;
}

/* Grid Max Width */
:host([max-width=xs]),
.ids-layout-grid.ids-layout-grid-max-width-xs {
  max-width: 320px;
}

:host([max-width=sm]),
.ids-layout-grid.ids-layout-grid-max-width-sm {
  max-width: 767px;
}

:host([max-width=md]),
.ids-layout-grid.ids-layout-grid-max-width-md {
  max-width: 927px;
}

:host([max-width=lg]),
.ids-layout-grid.ids-layout-grid-max-width-lg {
  max-width: 928px;
}

:host([max-width=xl]),
.ids-layout-grid.ids-layout-grid-max-width-xl {
  max-width: 1183px;
}

:host([max-width=xxl]),
.ids-layout-grid.ids-layout-grid-max-width-xxl {
  max-width: 2463px;
}

:host([max-width\$=px]) {
  max-width: var(--max-width);
}

/* Grid Padding */
:host([padding=xs]),
::slotted([padding=xs]),
.ids-layout-grid.ids-layout-grid-padding-xs {
  padding: 8px;
}

:host([padding=sm]),
::slotted([padding=sm]),
.ids-layout-grid.ids-layout-grid-padding-sm {
  padding: 16px;
}

:host([padding=md]),
::slotted([padding=md]),
.ids-layout-grid.ids-layout-grid-padding-md {
  padding: 24px;
}

:host([padding=lg]),
::slotted([padding=lg]),
.ids-layout-grid.ids-layout-grid-padding-lg {
  padding: 32px;
}

:host([padding=xl]),
::slotted([padding=xl]),
.ids-layout-grid.ids-layout-grid-padding-xl {
  padding: 40px;
}

/* Grid Padding X */
:host([padding-x=xs]),
.ids-layout-grid.ids-layout-grid-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-x=sm]),
.ids-layout-grid.ids-layout-grid-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-x=md]),
.ids-layout-grid.ids-layout-grid-padding-x-md {
  padding-inline: 24px;
}

:host([padding-x=lg]),
.ids-layout-grid.ids-layout-grid-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-x=xl]),
.ids-layout-grid.ids-layout-grid-padding-x-xl {
  padding-inline: 40px;
}

/* Grid Padding Y */
:host([padding-y=xs]),
.ids-layout-grid.ids-layout-grid-padding-y-xs {
  padding-block: 8px;
}

:host([padding-y=xxs]),
.ids-layout-grid.ids-layout-grid-padding-y-xxs {
  padding-block: 4px;
}

:host([padding-y=sm]),
.ids-layout-grid.ids-layout-grid-padding-y-sm {
  padding-block: 16px;
}

:host([padding-y=md]),
.ids-layout-grid.ids-layout-grid-padding-y-md {
  padding-block: 24px;
}

:host([padding-y=lg]),
.ids-layout-grid.ids-layout-grid-padding-y-lg {
  padding-block: 32px;
}

:host([padding-y=xl]),
.ids-layout-grid.ids-layout-grid-padding-y-xl {
  padding-block: 40px;
}

/* Grid - Auto Fit/Fill */
:host([auto-fit]),
.ids-layout-grid-auto-fit {
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(var(--min-col-width), var(--max-col-width)));
}

:host([auto-fill]),
.ids-layout-grid-auto-fill {
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(var(--min-col-width), var(--max-col-width)));
}

/* Grid - Auto Columns - TODO - Add settings for grid-auto-columns */
:host(.ids-layout-grid-cols-auto),
.ids-layout-grid-cols-auto {
  grid-auto-columns: auto;
}

:host(.ids-layout-grid-cols-min),
.ids-layout-grid-cols-min {
  grid-auto-columns: min-content;
}

:host(.ids-layout-grid-cols-max),
.ids-layout-grid-cols-max {
  grid-auto-columns: max-content;
}

:host(.ids-layout-grid-cols-fr),
.ids-layout-grid-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}

/* Grid Flow */
:host([flow=row]),
.ids-layout-grid-flow-row {
  grid-auto-flow: row;
}

:host([flow=column]),
.ids-layout-grid-flow-col {
  grid-auto-flow: column;
}

:host([flow=dense]),
.ids-layout-grid-flow-dense {
  grid-auto-flow: dense;
}

:host([flow=row-dense]),
.ids-layout-grid-flow-row-dense {
  grid-auto-flow: row dense;
}

:host([flow=column-dense]),
.ids-layout-grid-flow-col-dense {
  grid-auto-flow: column dense;
}

/* Grid - Auto Rows - TODO - Add settings for grid-auto-rows */
:host(.ids-layout-grid-auto-rows-auto),
.ids-layout-grid-auto-rows-auto {
  grid-auto-rows: auto;
}

:host(.ids-layout-grid-auto-rows-min),
.ids-layout-grid-auto-rows-min {
  grid-auto-rows: min-content;
}

:host(.ids-layout-grid-auto-rows-max),
.ids-layout-grid-auto-rows-max {
  grid-auto-rows: max-content;
}

:host(.ids-layout-grid-auto-rows-fr),
.ids-layout-grid-auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}

:host([row-height]),
.ids-layout-grid-auto-row-height {
  grid-auto-rows: var(--grid-auto-row-height);
}

/* Grid - Template Rows */
:host([template-rows]),
.ids-layout-grid-template-rows {
  grid-template-rows: var(--grid-template-rows);
}

/** Align items */
:host([align-items=start]),
.ids-layout-grid-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-grid-align-items-end {
  align-items: end;
}

:host([align-items=center]),
.ids-layout-grid-align-items-center {
  align-items: center;
}

:host([align-items=stretch]),
.ids-layout-grid-align-items-stretch {
  align-items: stretch;
}

:host([align-items=center-inputs]),
.ids-layout-grid-align-items-center-inputs {
  align-items: start;
}

:host([align-items=center-inputs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
}
:host([align-items=center-inputs]) ::slotted(ids-layout-grid-cell.has-checkbox) {
  align-self: end;
}

:host([align-items=center-inputs][field-height=xs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([align-items=center-inputs][field-height=sm]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
}

:host([align-items=center-inputs][field-height=lg]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
}

/* Justify Content and Align Content */
:host([justify-content=start]),
.ids-layout-grid-justify-start {
  justify-content: start;
}

:host([align-content=start]),
.ids-layout-grid-align-start {
  align-content: start;
}

::slotted([justify-content=start]),
.ids-layout-grid > .ids-layout-grid-justify-start {
  display: grid;
  justify-content: start;
}

::slotted([align-content=start]),
.ids-layout-grid > .ids-layout-grid-align-start {
  display: grid;
  align-content: start;
}

:host([justify-content=center]),
.ids-layout-grid-justify-center {
  justify-content: center;
}

:host([align-content=center]),
.ids-layout-grid-align-center {
  align-content: center;
}

::slotted([justify-content=center]),
.ids-layout-grid > .ids-layout-grid-justify-center {
  display: grid;
  justify-content: center;
}

::slotted([align-content=center]),
.ids-layout-grid > .ids-layout-grid-align-center {
  display: grid;
  align-content: center;
}

:host([justify-content=space-between]),
.ids-layout-grid-justify-space-between {
  justify-content: space-between;
}

:host([align-content=space-between]),
.ids-layout-grid-align-space-between {
  align-content: space-between;
}

::slotted([justify-content=space-between]),
.ids-layout-grid > .ids-layout-grid-justify-space-between {
  display: grid;
  justify-content: space-between;
}

::slotted([align-content=space-between]),
.ids-layout-grid > .ids-layout-grid-align-space-between {
  display: grid;
  align-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-grid-justify-space-around {
  justify-content: space-around;
}

:host([align-content=space-around]),
.ids-layout-grid-align-space-around {
  align-content: space-around;
}

::slotted([justify-content=space-around]),
.ids-layout-grid > .ids-layout-grid-justify-space-around {
  display: grid;
  justify-content: space-around;
}

::slotted([align-content=space-around]),
.ids-layout-grid > .ids-layout-grid-align-space-around {
  display: grid;
  align-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-grid-justify-space-evenly {
  justify-content: space-evenly;
}

:host([align-content=space-evenly]),
.ids-layout-grid-align-space-evenly {
  align-content: space-evenly;
}

::slotted([justify-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-justify-space-evenly {
  display: grid;
  justify-content: space-evenly;
}

::slotted([align-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-align-space-evenly {
  display: grid;
  align-content: space-evenly;
}

:host([justify-content=end]),
.ids-layout-grid-justify-end {
  justify-content: end;
}

:host([align-content=end]),
.ids-layout-grid-align-end {
  align-content: end;
}

::slotted([justify-content=end]),
.ids-layout-grid > .ids-layout-grid-justify-end {
  display: grid;
  justify-content: end;
}

::slotted([align-content=end]),
.ids-layout-grid > .ids-layout-grid-align-end {
  display: grid;
  align-content: end;
}

/* Grid Col/Row Span All and Sticky */
::slotted([col-span=all]),
.ids-layout-grid > .ids-layout-grid-col-span-all {
  grid-column: 1/-1;
}

::slotted([row-span=all]),
.ids-layout-grid > .ids-layout-grid-row-span-all {
  grid-row: 1/-1;
}

::slotted([sticky]),
.ids-layout-grid > .ids-layout-grid-sticky {
  position: sticky;
  top: var(--sticky-position);
}

/* Hide Cell on Breakpoints */
:host > ::slotted([hide=xs]) {
  display: none;
}

:host > ::slotted([hide=sm]) {
  display: none;
}

:host > ::slotted([hide=md]) {
  display: none;
}

:host > ::slotted([hide=lg]) {
  display: none;
}

:host > ::slotted([hide=xl]) {
  display: none;
}

:host > ::slotted([hide=xxl]) {
  display: none;
}

:host > ::slotted([hide=always]) {
  display: none;
}

:host([row-gap=none]),
::slotted([row-gap=none]),
.ids-layout-grid.ids-layout-grid-row-gap-none {
  row-gap: 0;
}

:host([row-gap=xs]),
::slotted([row-gap=xs]),
.ids-layout-grid.ids-layout-grid-row-gap-xs {
  row-gap: 8px;
}

:host([row-gap=sm]),
::slotted([row-gap=sm]),
.ids-layout-grid.ids-layout-grid-row-gap-sm {
  row-gap: 16px;
}

:host([row-gap=md]),
::slotted([row-gap=md]),
.ids-layout-grid.ids-layout-grid-row-gap-md {
  row-gap: 24px;
}

:host([row-gap=lg]),
::slotted([row-gap=lg]),
.ids-layout-grid.ids-layout-grid-row-gap-lg {
  row-gap: 32px;
}

:host([row-gap=xl]),
::slotted([row-gap=xl]),
.ids-layout-grid.ids-layout-grid-row-gap-xl {
  row-gap: 40px;
}

:host([col-gap=none]),
::slotted([col-gap=none]),
.ids-layout-grid.ids-layout-grid-col-gap-none {
  column-gap: 0;
}

:host([col-gap=xs]),
::slotted([col-gap=xs]),
.ids-layout-grid.ids-layout-grid-col-gap-xs {
  column-gap: 8px;
}

:host([col-gap=sm]),
::slotted([col-gap=sm]),
.ids-layout-grid.ids-layout-grid-col-gap-sm {
  column-gap: 16px;
}

:host([col-gap=md]),
::slotted([col-gap=md]),
.ids-layout-grid.ids-layout-grid-col-gap-md {
  column-gap: 24px;
}

:host([col-gap=lg]),
::slotted([col-gap=lg]),
.ids-layout-grid.ids-layout-grid-col-gap-lg {
  column-gap: 32px;
}

:host([col-gap=xl]),
::slotted([col-gap=xl]),
.ids-layout-grid.ids-layout-grid-col-gap-xl {
  column-gap: 40px;
}

/* Editable */
::slotted([editable]) > ids-button,
.ids-layout-grid > .ids-layout-grid-cell.editable > ids-button {
  position: absolute;
  top: 0;
  right: 0;
}

/* Fill */
::slotted([fill]),
.ids-layout-grid > .ids-layout-grid-cell.fill {
  background-color: var(--grid-fill-color);
  color: var(--grid-text-color);
}

/* Height */
::slotted([height=auto]),
.ids-layout-grid > .ids-layout-grid-height-auto {
  height: auto;
}

/* When containing an auto-fit data grid cell, fill available height */
:host(.ids-layout-grid-has-auto-fit-cell) {
  block-size: 100%;
  min-block-size: 0;
  grid-auto-rows: minmax(0, 1fr);
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  block-size: 100%;
  min-block-size: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
